/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './../routes/__root'
import { Route as AuthenticatedImport } from './../routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './../routes/_authenticated/index'
import { Route as AuthLayoutImport } from './../routes/auth/_layout'
import { Route as TenantSlugNoAccessIndexImport } from './../routes/$tenantSlug/no-access/index'
import { Route as TenantSlugConfirmDeletionIndexImport } from './../routes/$tenantSlug/confirm-deletion/index'
import { Route as AuthenticatedAccountLayoutImport } from './../routes/_authenticated/account/_layout'
import { Route as AuthenticatedTenantSlugLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout'
import { Route as TenantSlugProcessesLayoutImport } from './../routes/$tenantSlug/processes/_layout'
import { Route as TenantSlugAuthLayoutImport } from './../routes/$tenantSlug/auth/_layout'
import { Route as AuthLayoutRegistrationIndexImport } from './../routes/auth/_layout/registration/index'
import { Route as AuthLayoutLoginIndexImport } from './../routes/auth/_layout/login/index'
import { Route as AuthLayoutForgotPasswordIndexImport } from './../routes/auth/_layout/forgot-password/index'
import { Route as AuthLayoutChangePasswordIndexImport } from './../routes/auth/_layout/change-password/index'
import { Route as AuthenticatedAccountLayoutIndexImport } from './../routes/_authenticated/account/_layout/index'
import { Route as AuthenticatedTenantSlugLayoutIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/index'
import { Route as AuthenticatedAccountLayoutSettingsIndexImport } from './../routes/_authenticated/account/_layout/settings/index'
import { Route as AuthenticatedAccountLayoutPartnersIndexImport } from './../routes/_authenticated/account/_layout/partners/index'
import { Route as AuthenticatedAccountLayoutCatalogIndexImport } from './../routes/_authenticated/account/_layout/catalog/index'
import { Route as AuthenticatedTenantSlugLayoutToolIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/index'
import { Route as AuthenticatedTenantSlugLayoutSettingIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/index'
import { Route as AuthenticatedTenantSlugLayoutReportIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/index'
import { Route as AuthenticatedTenantSlugLayoutOfferIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/index'
import { Route as AuthenticatedTenantSlugLayoutLogIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/index'
import { Route as AuthenticatedTenantSlugLayoutFinanceIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/finance/index'
import { Route as TenantSlugProcessesLayoutProcessIdIndexImport } from './../routes/$tenantSlug/processes/_layout/$processId/index'
import { Route as TenantSlugAuthLayoutRegistrationIndexImport } from './../routes/$tenantSlug/auth/_layout/registration/index'
import { Route as TenantSlugAuthLayoutRegistrationAdvertiserIndexImport } from './../routes/$tenantSlug/auth/_layout/registration-advertiser/index'
import { Route as TenantSlugAuthLayoutLoginIndexImport } from './../routes/$tenantSlug/auth/_layout/login/index'
import { Route as TenantSlugAuthLayoutForgotPasswordIndexImport } from './../routes/$tenantSlug/auth/_layout/forgot-password/index'
import { Route as TenantSlugAuthLayoutConfirmRegistrationIndexImport } from './../routes/$tenantSlug/auth/_layout/confirm-registration/index'
import { Route as TenantSlugAuthLayoutChangePasswordIndexImport } from './../routes/$tenantSlug/auth/_layout/change-password/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout'
import { Route as AuthenticatedTenantSlugLayoutSettingLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/_layout'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout'
import { Route as AuthenticatedTenantSlugLayoutFinanceLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/finance/_layout'
import { Route as AuthenticatedTenantSlugLayoutAffiliateLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/affiliate/_layout'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout'
import { Route as AuthLayoutActivateUserIdEmailHashIndexImport } from './../routes/auth/_layout/activate/$userId/$emailHash/index'
import { Route as AuthenticatedTenantSlugLayoutAffiliateLayoutIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/index'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/index'
import { Route as TenantSlugAuthLayoutAcceptInvitationIdHashImport } from './../routes/$tenantSlug/auth/_layout/accept-invitation/$id/$hash'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutValidationIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/index'
import { Route as AuthenticatedTenantSlugLayoutSettingLayoutUserIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/_layout/user/index'
import { Route as AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/index'
import { Route as AuthenticatedTenantSlugLayoutSettingLayoutTagIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/_layout/tag/index'
import { Route as AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/_layout/plan/index'
import { Route as AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/setting/_layout/field/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/transaction/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutPingIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/ping/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/performance/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutOfferIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/offer/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutEventIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/event/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutValidationIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/validation/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutStructureIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/structure/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutLeadIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/lead/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutConversionIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/conversion/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutClickIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/click/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutApiIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/api/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/api-old/index'
import { Route as AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/index'
import { Route as AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/index'
import { Route as AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/finance/_layout/cost/index'
import { Route as AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/index'
import { Route as AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/index'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/index'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/index'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/index'
import { Route as TenantSlugAuthLayoutActivateUserIdEmailHashIndexImport } from './../routes/$tenantSlug/auth/_layout/activate/$userId/$emailHash/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout'
import { Route as AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/index'
import { Route as AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/index'
import { Route as AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/index'
import { Route as AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/index'
import { Route as AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/index'
import { Route as AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/index'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/index'
import { Route as AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/index'
import { Route as AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/index'
import { Route as AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexImport } from './../routes/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/index'

// Create Virtual Routes

const AuthImport = createFileRoute('/auth')()
const AuthenticatedAccountImport = createFileRoute('/_authenticated/account')()
const AuthenticatedTenantSlugImport = createFileRoute(
  '/_authenticated/$tenantSlug',
)()
const TenantSlugProcessesImport = createFileRoute('/$tenantSlug/processes')()
const TenantSlugAuthImport = createFileRoute('/$tenantSlug/auth')()
const AuthenticatedTenantSlugLayoutToolImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/tool',
)()
const AuthenticatedTenantSlugLayoutSettingImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/setting',
)()
const AuthenticatedTenantSlugLayoutReportImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/report',
)()
const AuthenticatedTenantSlugLayoutOfferImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/offer',
)()
const AuthenticatedTenantSlugLayoutLogImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/log',
)()
const AuthenticatedTenantSlugLayoutFinanceImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/finance',
)()
const AuthenticatedTenantSlugLayoutAffiliateImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/affiliate',
)()
const AuthenticatedTenantSlugLayoutAdvertiserImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/advertiser',
)()
const AuthenticatedTenantSlugLayoutToolLayoutValidationImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation',
)()
const AuthenticatedTenantSlugLayoutToolLayoutTrackingImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking',
)()
const AuthenticatedTenantSlugLayoutToolLayoutStructureImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure',
)()
const AuthenticatedTenantSlugLayoutToolLayoutScenarioImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario',
)()
const AuthenticatedTenantSlugLayoutToolLayoutDesignImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design',
)()
const AuthenticatedTenantSlugLayoutReportLayoutPingtreeImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree',
)()
const AuthenticatedTenantSlugLayoutReportLayoutOfferImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/report/_layout/offer',
)()
const AuthenticatedTenantSlugLayoutReportLayoutAffiliateImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate',
  )()
const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser',
  )()
const AuthenticatedTenantSlugLayoutLogLayoutTrackingImport = createFileRoute(
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking',
)()
const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission',
  )()
const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request',
  )()
const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId',
  )()
const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId',
  )()
const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdImport =
  createFileRoute(
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId',
  )()

// Create/Update Routes

const AuthRoute = AuthImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedAccountRoute = AuthenticatedAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedTenantSlugRoute = AuthenticatedTenantSlugImport.update({
  id: '/$tenantSlug',
  path: '/$tenantSlug',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const TenantSlugProcessesRoute = TenantSlugProcessesImport.update({
  id: '/$tenantSlug/processes',
  path: '/$tenantSlug/processes',
  getParentRoute: () => rootRoute,
} as any)

const TenantSlugAuthRoute = TenantSlugAuthImport.update({
  id: '/$tenantSlug/auth',
  path: '/$tenantSlug/auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthLayoutRoute = AuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any)

const TenantSlugNoAccessIndexRoute = TenantSlugNoAccessIndexImport.update({
  id: '/$tenantSlug/no-access/',
  path: '/$tenantSlug/no-access/',
  getParentRoute: () => rootRoute,
} as any)

const TenantSlugConfirmDeletionIndexRoute =
  TenantSlugConfirmDeletionIndexImport.update({
    id: '/$tenantSlug/confirm-deletion/',
    path: '/$tenantSlug/confirm-deletion/',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedAccountLayoutRoute = AuthenticatedAccountLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any,
)

const AuthenticatedTenantSlugLayoutRoute =
  AuthenticatedTenantSlugLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugRoute,
  } as any)

const TenantSlugProcessesLayoutRoute = TenantSlugProcessesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => TenantSlugProcessesRoute,
} as any)

const TenantSlugAuthLayoutRoute = TenantSlugAuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => TenantSlugAuthRoute,
} as any)

const AuthenticatedTenantSlugLayoutToolRoute =
  AuthenticatedTenantSlugLayoutToolImport.update({
    id: '/tool',
    path: '/tool',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingRoute =
  AuthenticatedTenantSlugLayoutSettingImport.update({
    id: '/setting',
    path: '/setting',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportRoute =
  AuthenticatedTenantSlugLayoutReportImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferRoute =
  AuthenticatedTenantSlugLayoutOfferImport.update({
    id: '/offer',
    path: '/offer',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogRoute =
  AuthenticatedTenantSlugLayoutLogImport.update({
    id: '/log',
    path: '/log',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutFinanceRoute =
  AuthenticatedTenantSlugLayoutFinanceImport.update({
    id: '/finance',
    path: '/finance',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateRoute =
  AuthenticatedTenantSlugLayoutAffiliateImport.update({
    id: '/affiliate',
    path: '/affiliate',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserRoute =
  AuthenticatedTenantSlugLayoutAdvertiserImport.update({
    id: '/advertiser',
    path: '/advertiser',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthLayoutRegistrationIndexRoute =
  AuthLayoutRegistrationIndexImport.update({
    id: '/registration/',
    path: '/registration/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)

const AuthLayoutLoginIndexRoute = AuthLayoutLoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutForgotPasswordIndexRoute =
  AuthLayoutForgotPasswordIndexImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)

const AuthLayoutChangePasswordIndexRoute =
  AuthLayoutChangePasswordIndexImport.update({
    id: '/change-password/',
    path: '/change-password/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)

const AuthenticatedAccountLayoutIndexRoute =
  AuthenticatedAccountLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutIndexRoute =
  AuthenticatedTenantSlugLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutRoute,
  } as any)

const AuthenticatedAccountLayoutSettingsIndexRoute =
  AuthenticatedAccountLayoutSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedAccountLayoutRoute,
  } as any)

const AuthenticatedAccountLayoutPartnersIndexRoute =
  AuthenticatedAccountLayoutPartnersIndexImport.update({
    id: '/partners/',
    path: '/partners/',
    getParentRoute: () => AuthenticatedAccountLayoutRoute,
  } as any)

const AuthenticatedAccountLayoutCatalogIndexRoute =
  AuthenticatedAccountLayoutCatalogIndexImport.update({
    id: '/catalog/',
    path: '/catalog/',
    getParentRoute: () => AuthenticatedAccountLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolIndexRoute =
  AuthenticatedTenantSlugLayoutToolIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingIndexRoute =
  AuthenticatedTenantSlugLayoutSettingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportIndexRoute =
  AuthenticatedTenantSlugLayoutReportIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferIndexRoute =
  AuthenticatedTenantSlugLayoutOfferIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutOfferRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogIndexRoute =
  AuthenticatedTenantSlugLayoutLogIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogRoute,
  } as any)

const AuthenticatedTenantSlugLayoutFinanceIndexRoute =
  AuthenticatedTenantSlugLayoutFinanceIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutFinanceRoute,
  } as any)

const TenantSlugProcessesLayoutProcessIdIndexRoute =
  TenantSlugProcessesLayoutProcessIdIndexImport.update({
    id: '/$processId/',
    path: '/$processId/',
    getParentRoute: () => TenantSlugProcessesLayoutRoute,
  } as any)

const TenantSlugAuthLayoutRegistrationIndexRoute =
  TenantSlugAuthLayoutRegistrationIndexImport.update({
    id: '/registration/',
    path: '/registration/',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute =
  TenantSlugAuthLayoutRegistrationAdvertiserIndexImport.update({
    id: '/registration-advertiser/',
    path: '/registration-advertiser/',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const TenantSlugAuthLayoutLoginIndexRoute =
  TenantSlugAuthLayoutLoginIndexImport.update({
    id: '/login/',
    path: '/login/',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const TenantSlugAuthLayoutForgotPasswordIndexRoute =
  TenantSlugAuthLayoutForgotPasswordIndexImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const TenantSlugAuthLayoutConfirmRegistrationIndexRoute =
  TenantSlugAuthLayoutConfirmRegistrationIndexImport.update({
    id: '/confirm-registration/',
    path: '/confirm-registration/',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const TenantSlugAuthLayoutChangePasswordIndexRoute =
  TenantSlugAuthLayoutChangePasswordIndexImport.update({
    id: '/change-password/',
    path: '/change-password/',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingLayoutRoute =
  AuthenticatedTenantSlugLayoutSettingLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutRoute =
  AuthenticatedTenantSlugLayoutReportLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferLayoutRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutOfferRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutRoute =
  AuthenticatedTenantSlugLayoutLogLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogRoute,
  } as any)

const AuthenticatedTenantSlugLayoutFinanceLayoutRoute =
  AuthenticatedTenantSlugLayoutFinanceLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutFinanceRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateLayoutRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAffiliateRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAdvertiserRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutValidationRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationImport.update({
    id: '/validation',
    path: '/validation',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutTrackingRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutStructureRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureImport.update({
    id: '/structure',
    path: '/structure',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutScenarioRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioImport.update({
    id: '/scenario',
    path: '/scenario',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutDesignRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignImport.update({
    id: '/design',
    path: '/design',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeRoute =
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeImport.update({
    id: '/pingtree',
    path: '/pingtree',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutOfferRoute =
  AuthenticatedTenantSlugLayoutReportLayoutOfferImport.update({
    id: '/offer',
    path: '/offer',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateImport.update({
    id: '/affiliate',
    path: '/affiliate',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserImport.update({
    id: '/advertiser',
    path: '/advertiser',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutTrackingRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionImport.update({
    id: '/commission',
    path: '/commission',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAffiliateLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestImport.update({
    id: '/request',
    path: '/request',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute,
  } as any)

const AuthLayoutActivateUserIdEmailHashIndexRoute =
  AuthLayoutActivateUserIdEmailHashIndexImport.update({
    id: '/activate/$userId/$emailHash/',
    path: '/activate/$userId/$emailHash/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAffiliateLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute,
  } as any)

const TenantSlugAuthLayoutAcceptInvitationIdHashRoute =
  TenantSlugAuthLayoutAcceptInvitationIdHashImport.update({
    id: '/accept-invitation/$id/$hash',
    path: '/accept-invitation/$id/$hash',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdImport.update({
    id: '/edit/$offerId',
    path: '/edit/$offerId',
    getParentRoute: () => AuthenticatedTenantSlugLayoutOfferLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdImport.update({
    id: '/detail/$offerId',
    path: '/detail/$offerId',
    getParentRoute: () => AuthenticatedTenantSlugLayoutOfferLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutValidationRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutTrackingRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutStructureRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutScenarioRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutDesignRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute =
  AuthenticatedTenantSlugLayoutSettingLayoutUserIndexImport.update({
    id: '/user/',
    path: '/user/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute =
  AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexImport.update({
    id: '/tracking/',
    path: '/tracking/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute =
  AuthenticatedTenantSlugLayoutSettingLayoutTagIndexImport.update({
    id: '/tag/',
    path: '/tag/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute =
  AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexImport.update({
    id: '/plan/',
    path: '/plan/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute =
  AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexImport.update({
    id: '/field/',
    path: '/field/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutSettingLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexImport.update({
    id: '/transaction/',
    path: '/transaction/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutReportLayoutPingtreeRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutPingIndexImport.update({
    id: '/ping/',
    path: '/ping/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexImport.update({
    id: '/performance/',
    path: '/performance/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutOfferIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutOfferRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutEventIndexImport.update({
    id: '/event/',
    path: '/event/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutReportLayoutAffiliateRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutValidationIndexImport.update({
    id: '/validation/',
    path: '/validation/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutTrackingRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutStructureIndexImport.update({
    id: '/structure/',
    path: '/structure/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexImport.update({
    id: '/pingtree/',
    path: '/pingtree/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutLeadIndexImport.update({
    id: '/lead/',
    path: '/lead/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutConversionIndexImport.update({
    id: '/conversion/',
    path: '/conversion/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutClickIndexImport.update({
    id: '/click/',
    path: '/click/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutApiIndexImport.update({
    id: '/api/',
    path: '/api/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexImport.update({
    id: '/api-old/',
    path: '/api-old/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute =
  AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexImport.update({
    id: '/revenue/',
    path: '/revenue/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutFinanceLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute =
  AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexImport.update({
    id: '/penalty/',
    path: '/penalty/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutFinanceLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute =
  AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexImport.update({
    id: '/cost/',
    path: '/cost/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutFinanceLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute =
  AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexImport.update({
    id: '/bonus/',
    path: '/bonus/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutFinanceLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexImport.update({
    id: '/transaction/',
    path: '/transaction/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexImport.update({
    id: '/commission/',
    path: '/commission/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute,
  } as any)

const TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute =
  TenantSlugAuthLayoutActivateUserIdEmailHashIndexImport.update({
    id: '/activate/$userId/$emailHash/',
    path: '/activate/$userId/$emailHash/',
    getParentRoute: () => TenantSlugAuthLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutValidationRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutTrackingRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutStructureRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutScenarioRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutToolLayoutDesignRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRoute =
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutReportLayoutPingtreeRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRoute =
  AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutReportLayoutOfferRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutReportLayoutAffiliateRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedTenantSlugLayoutLogLayoutTrackingRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdImport.update(
    {
      id: '/$scenarioId',
      path: '/$scenarioId',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiImport.update(
    {
      id: '/tracking-api',
      path: '/tracking-api',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackImport.update(
    {
      id: '/s2s-postback',
      path: '/s2s-postback',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserImport.update({
    id: '/user',
    path: '/user',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadImport.update({
    id: '/lead',
    path: '/lead',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedImport.update({
    id: '/feed',
    path: '/feed',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationImport.update(
    {
      id: '/integration',
      path: '/integration',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormImport.update({
    id: '/form',
    path: '/form',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexImport.update({
    id: '/request/payout/',
    path: '/request/payout/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAffiliateLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexImport.update({
    id: '/request/offer/',
    path: '/request/offer/',
    getParentRoute: () => AuthenticatedTenantSlugLayoutAffiliateLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRoute,
  } as any)

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexImport.update({
    id: '/screen/',
    path: '/screen/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexImport.update({
    id: '/funnel/',
    path: '/funnel/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRoute,
  } as any)

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexImport.update(
    {
      id: '/$pingtreeId/',
      path: '/$pingtreeId/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexImport.update(
    {
      id: '/$offerId/',
      path: '/$offerId/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexImport.update(
    {
      id: '/$userId/',
      path: '/$userId/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute =
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexImport.update(
    {
      id: '/$userId/',
      path: '/$userId/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexImport.update(
    {
      id: '/tracking-api/',
      path: '/tracking-api/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexImport.update(
    {
      id: '/tracking-api-steps/',
      path: '/tracking-api-steps/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexImport.update({
    id: '/to/',
    path: '/to/',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute,
  } as any)

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexImport.update(
    {
      id: '/s2s-postback/',
      path: '/s2s-postback/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexImport.update(
    {
      id: '/s2s-postback-steps/',
      path: '/s2s-postback-steps/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute =
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexImport.update(
    {
      id: '/$commissionGroupId/',
      path: '/$commissionGroupId/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexImport.update(
    {
      id: '/payout/',
      path: '/payout/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexImport.update(
    {
      id: '/entry/',
      path: '/entry/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRoute,
  } as any)

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdImport.update(
    {
      id: '/$id',
      path: '/$id',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdImport.update(
    {
      id: '/$id',
      path: '/$id',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdImport.update(
    {
      id: '/$formStructureId',
      path: '/$formStructureId',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdImport.update(
    {
      id: '/$formStructureId',
      path: '/$formStructureId',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdImport.update(
    {
      id: '/$formStructureId',
      path: '/$formStructureId',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdImport.update(
    {
      id: '/$integrationId',
      path: '/$integrationId',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdImport.update(
    {
      id: '/$formId',
      path: '/$formId',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexImport.update(
    {
      id: '/pingtree/',
      path: '/pingtree/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexImport.update(
    {
      id: '/link/',
      path: '/link/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexImport.update(
    {
      id: '/form/',
      path: '/form/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexImport.update(
    {
      id: '/filter/',
      path: '/filter/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexImport.update(
    {
      id: '/api/',
      path: '/api/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexImport.update(
    {
      id: '/link/',
      path: '/link/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexImport.update(
    {
      id: '/form/',
      path: '/form/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexImport.update(
    {
      id: '/api/',
      path: '/api/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexImport.update(
    {
      id: '/editor/',
      path: '/editor/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexImport.update(
    {
      id: '/editor/',
      path: '/editor/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexImport.update(
    {
      id: '/editor-old/',
      path: '/editor-old/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexImport.update(
    {
      id: '/editor/',
      path: '/editor/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexImport.update(
    {
      id: '/editor-old/',
      path: '/editor-old/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexImport.update(
    {
      id: '/structure/',
      path: '/structure/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexImport.update(
    {
      id: '/editor-old/',
      path: '/editor-old/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexImport.update(
    {
      id: '/structure/',
      path: '/structure/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexImport.update(
    {
      id: '/editor-old/',
      path: '/editor-old/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexImport.update(
    {
      id: '/structure/',
      path: '/structure/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexImport.update(
    {
      id: '/editor-old/',
      path: '/editor-old/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexImport.update(
    {
      id: '/editor/',
      path: '/editor/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexImport.update(
    {
      id: '/editor-old/',
      path: '/editor-old/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexImport.update(
    {
      id: '/preview/',
      path: '/preview/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRoute,
    } as any,
  )

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexImport.update(
    {
      id: '/general/',
      path: '/general/',
      getParentRoute: () =>
        AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/auth/_layout': {
      id: '/auth/_layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthLayoutImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/$tenantSlug/auth': {
      id: '/$tenantSlug/auth'
      path: '/$tenantSlug/auth'
      fullPath: '/$tenantSlug/auth'
      preLoaderRoute: typeof TenantSlugAuthImport
      parentRoute: typeof rootRoute
    }
    '/$tenantSlug/auth/_layout': {
      id: '/$tenantSlug/auth/_layout'
      path: '/$tenantSlug/auth'
      fullPath: '/$tenantSlug/auth'
      preLoaderRoute: typeof TenantSlugAuthLayoutImport
      parentRoute: typeof TenantSlugAuthRoute
    }
    '/$tenantSlug/processes': {
      id: '/$tenantSlug/processes'
      path: '/$tenantSlug/processes'
      fullPath: '/$tenantSlug/processes'
      preLoaderRoute: typeof TenantSlugProcessesImport
      parentRoute: typeof rootRoute
    }
    '/$tenantSlug/processes/_layout': {
      id: '/$tenantSlug/processes/_layout'
      path: '/$tenantSlug/processes'
      fullPath: '/$tenantSlug/processes'
      preLoaderRoute: typeof TenantSlugProcessesLayoutImport
      parentRoute: typeof TenantSlugProcessesRoute
    }
    '/_authenticated/$tenantSlug': {
      id: '/_authenticated/$tenantSlug'
      path: '/$tenantSlug'
      fullPath: '/$tenantSlug'
      preLoaderRoute: typeof AuthenticatedTenantSlugImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/$tenantSlug/_layout': {
      id: '/_authenticated/$tenantSlug/_layout'
      path: '/$tenantSlug'
      fullPath: '/$tenantSlug'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/account/_layout': {
      id: '/_authenticated/account/_layout'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountLayoutImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/$tenantSlug/confirm-deletion/': {
      id: '/$tenantSlug/confirm-deletion/'
      path: '/$tenantSlug/confirm-deletion'
      fullPath: '/$tenantSlug/confirm-deletion'
      preLoaderRoute: typeof TenantSlugConfirmDeletionIndexImport
      parentRoute: typeof rootRoute
    }
    '/$tenantSlug/no-access/': {
      id: '/$tenantSlug/no-access/'
      path: '/$tenantSlug/no-access'
      fullPath: '/$tenantSlug/no-access'
      preLoaderRoute: typeof TenantSlugNoAccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/$tenantSlug/_layout/': {
      id: '/_authenticated/$tenantSlug/_layout/'
      path: '/'
      fullPath: '/$tenantSlug/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/account/_layout/': {
      id: '/_authenticated/account/_layout/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountLayoutIndexImport
      parentRoute: typeof AuthenticatedAccountLayoutImport
    }
    '/auth/_layout/change-password/': {
      id: '/auth/_layout/change-password/'
      path: '/change-password'
      fullPath: '/auth/change-password'
      preLoaderRoute: typeof AuthLayoutChangePasswordIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/forgot-password/': {
      id: '/auth/_layout/forgot-password/'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthLayoutForgotPasswordIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/login/': {
      id: '/auth/_layout/login/'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLayoutLoginIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/registration/': {
      id: '/auth/_layout/registration/'
      path: '/registration'
      fullPath: '/auth/registration'
      preLoaderRoute: typeof AuthLayoutRegistrationIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser'
      path: '/advertiser'
      fullPath: '/$tenantSlug/advertiser'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout'
      path: '/advertiser'
      fullPath: '/$tenantSlug/advertiser'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserRoute
    }
    '/_authenticated/$tenantSlug/_layout/affiliate': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate'
      path: '/affiliate'
      fullPath: '/$tenantSlug/affiliate'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout'
      path: '/affiliate'
      fullPath: '/$tenantSlug/affiliate'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateRoute
    }
    '/_authenticated/$tenantSlug/_layout/finance': {
      id: '/_authenticated/$tenantSlug/_layout/finance'
      path: '/finance'
      fullPath: '/$tenantSlug/finance'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutFinanceImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/finance/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/finance/_layout'
      path: '/finance'
      fullPath: '/$tenantSlug/finance'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutFinanceRoute
    }
    '/_authenticated/$tenantSlug/_layout/log': {
      id: '/_authenticated/$tenantSlug/_layout/log'
      path: '/log'
      fullPath: '/$tenantSlug/log'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout'
      path: '/log'
      fullPath: '/$tenantSlug/log'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogRoute
    }
    '/_authenticated/$tenantSlug/_layout/offer': {
      id: '/_authenticated/$tenantSlug/_layout/offer'
      path: '/offer'
      fullPath: '/$tenantSlug/offer'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout'
      path: '/offer'
      fullPath: '/$tenantSlug/offer'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferRoute
    }
    '/_authenticated/$tenantSlug/_layout/report': {
      id: '/_authenticated/$tenantSlug/_layout/report'
      path: '/report'
      fullPath: '/$tenantSlug/report'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout'
      path: '/report'
      fullPath: '/$tenantSlug/report'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportRoute
    }
    '/_authenticated/$tenantSlug/_layout/setting': {
      id: '/_authenticated/$tenantSlug/_layout/setting'
      path: '/setting'
      fullPath: '/$tenantSlug/setting'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/setting/_layout'
      path: '/setting'
      fullPath: '/$tenantSlug/setting'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool': {
      id: '/_authenticated/$tenantSlug/_layout/tool'
      path: '/tool'
      fullPath: '/$tenantSlug/tool'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout'
      path: '/tool'
      fullPath: '/$tenantSlug/tool'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolRoute
    }
    '/$tenantSlug/auth/_layout/change-password/': {
      id: '/$tenantSlug/auth/_layout/change-password/'
      path: '/change-password'
      fullPath: '/$tenantSlug/auth/change-password'
      preLoaderRoute: typeof TenantSlugAuthLayoutChangePasswordIndexImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/$tenantSlug/auth/_layout/confirm-registration/': {
      id: '/$tenantSlug/auth/_layout/confirm-registration/'
      path: '/confirm-registration'
      fullPath: '/$tenantSlug/auth/confirm-registration'
      preLoaderRoute: typeof TenantSlugAuthLayoutConfirmRegistrationIndexImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/$tenantSlug/auth/_layout/forgot-password/': {
      id: '/$tenantSlug/auth/_layout/forgot-password/'
      path: '/forgot-password'
      fullPath: '/$tenantSlug/auth/forgot-password'
      preLoaderRoute: typeof TenantSlugAuthLayoutForgotPasswordIndexImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/$tenantSlug/auth/_layout/login/': {
      id: '/$tenantSlug/auth/_layout/login/'
      path: '/login'
      fullPath: '/$tenantSlug/auth/login'
      preLoaderRoute: typeof TenantSlugAuthLayoutLoginIndexImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/$tenantSlug/auth/_layout/registration-advertiser/': {
      id: '/$tenantSlug/auth/_layout/registration-advertiser/'
      path: '/registration-advertiser'
      fullPath: '/$tenantSlug/auth/registration-advertiser'
      preLoaderRoute: typeof TenantSlugAuthLayoutRegistrationAdvertiserIndexImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/$tenantSlug/auth/_layout/registration/': {
      id: '/$tenantSlug/auth/_layout/registration/'
      path: '/registration'
      fullPath: '/$tenantSlug/auth/registration'
      preLoaderRoute: typeof TenantSlugAuthLayoutRegistrationIndexImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/$tenantSlug/processes/_layout/$processId/': {
      id: '/$tenantSlug/processes/_layout/$processId/'
      path: '/$processId'
      fullPath: '/$tenantSlug/processes/$processId'
      preLoaderRoute: typeof TenantSlugProcessesLayoutProcessIdIndexImport
      parentRoute: typeof TenantSlugProcessesLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/finance/': {
      id: '/_authenticated/$tenantSlug/_layout/finance/'
      path: '/'
      fullPath: '/$tenantSlug/finance/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutFinanceIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutFinanceImport
    }
    '/_authenticated/$tenantSlug/_layout/log/': {
      id: '/_authenticated/$tenantSlug/_layout/log/'
      path: '/'
      fullPath: '/$tenantSlug/log/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/'
      path: '/'
      fullPath: '/$tenantSlug/offer/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferImport
    }
    '/_authenticated/$tenantSlug/_layout/report/': {
      id: '/_authenticated/$tenantSlug/_layout/report/'
      path: '/'
      fullPath: '/$tenantSlug/report/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/': {
      id: '/_authenticated/$tenantSlug/_layout/setting/'
      path: '/'
      fullPath: '/$tenantSlug/setting/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/'
      path: '/'
      fullPath: '/$tenantSlug/tool/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolImport
    }
    '/_authenticated/account/_layout/catalog/': {
      id: '/_authenticated/account/_layout/catalog/'
      path: '/catalog'
      fullPath: '/account/catalog'
      preLoaderRoute: typeof AuthenticatedAccountLayoutCatalogIndexImport
      parentRoute: typeof AuthenticatedAccountLayoutImport
    }
    '/_authenticated/account/_layout/partners/': {
      id: '/_authenticated/account/_layout/partners/'
      path: '/partners'
      fullPath: '/account/partners'
      preLoaderRoute: typeof AuthenticatedAccountLayoutPartnersIndexImport
      parentRoute: typeof AuthenticatedAccountLayoutImport
    }
    '/_authenticated/account/_layout/settings/': {
      id: '/_authenticated/account/_layout/settings/'
      path: '/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AuthenticatedAccountLayoutSettingsIndexImport
      parentRoute: typeof AuthenticatedAccountLayoutImport
    }
    '/$tenantSlug/auth/_layout/accept-invitation/$id/$hash': {
      id: '/$tenantSlug/auth/_layout/accept-invitation/$id/$hash'
      path: '/accept-invitation/$id/$hash'
      fullPath: '/$tenantSlug/auth/accept-invitation/$id/$hash'
      preLoaderRoute: typeof TenantSlugAuthLayoutAcceptInvitationIdHashImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/'
      path: '/'
      fullPath: '/$tenantSlug/advertiser/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout/'
      path: '/'
      fullPath: '/$tenantSlug/affiliate/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutImport
    }
    '/auth/_layout/activate/$userId/$emailHash/': {
      id: '/auth/_layout/activate/$userId/$emailHash/'
      path: '/activate/$userId/$emailHash'
      fullPath: '/auth/activate/$userId/$emailHash'
      preLoaderRoute: typeof AuthLayoutActivateUserIdEmailHashIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request'
      path: '/request'
      fullPath: '/$tenantSlug/advertiser/request'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout'
      path: '/request'
      fullPath: '/$tenantSlug/advertiser/request'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRoute
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission'
      path: '/commission'
      fullPath: '/$tenantSlug/affiliate/commission'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout'
      path: '/commission'
      fullPath: '/$tenantSlug/affiliate/commission'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRoute
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking'
      path: '/tracking'
      fullPath: '/$tenantSlug/log/tracking'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout'
      path: '/tracking'
      fullPath: '/$tenantSlug/log/tracking'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingRoute
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser'
      path: '/advertiser'
      fullPath: '/$tenantSlug/report/advertiser'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout'
      path: '/advertiser'
      fullPath: '/$tenantSlug/report/advertiser'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRoute
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate'
      path: '/affiliate'
      fullPath: '/$tenantSlug/report/affiliate'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout'
      path: '/affiliate'
      fullPath: '/$tenantSlug/report/affiliate'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateRoute
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/offer': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/offer'
      path: '/offer'
      fullPath: '/$tenantSlug/report/offer'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout'
      path: '/offer'
      fullPath: '/$tenantSlug/report/offer'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferRoute
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree'
      path: '/pingtree'
      fullPath: '/$tenantSlug/report/pingtree'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout'
      path: '/pingtree'
      fullPath: '/$tenantSlug/report/pingtree'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design'
      path: '/design'
      fullPath: '/$tenantSlug/tool/design'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout'
      path: '/design'
      fullPath: '/$tenantSlug/tool/design'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario'
      path: '/scenario'
      fullPath: '/$tenantSlug/tool/scenario'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout'
      path: '/scenario'
      fullPath: '/$tenantSlug/tool/scenario'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure'
      path: '/structure'
      fullPath: '/$tenantSlug/tool/structure'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout'
      path: '/structure'
      fullPath: '/$tenantSlug/tool/structure'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking'
      path: '/tracking'
      fullPath: '/$tenantSlug/tool/tracking'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout'
      path: '/tracking'
      fullPath: '/$tenantSlug/tool/tracking'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation'
      path: '/validation'
      fullPath: '/$tenantSlug/tool/validation'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout'
      path: '/validation'
      fullPath: '/$tenantSlug/tool/validation'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationRoute
    }
    '/$tenantSlug/auth/_layout/activate/$userId/$emailHash/': {
      id: '/$tenantSlug/auth/_layout/activate/$userId/$emailHash/'
      path: '/activate/$userId/$emailHash'
      fullPath: '/$tenantSlug/auth/activate/$userId/$emailHash'
      preLoaderRoute: typeof TenantSlugAuthLayoutActivateUserIdEmailHashIndexImport
      parentRoute: typeof TenantSlugAuthLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/'
      path: '/commission'
      fullPath: '/$tenantSlug/advertiser/commission'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/'
      path: '/'
      fullPath: '/$tenantSlug/advertiser/request/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/'
      path: '/transaction'
      fullPath: '/$tenantSlug/advertiser/transaction'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/'
      path: '/'
      fullPath: '/$tenantSlug/affiliate/commission/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionImport
    }
    '/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/': {
      id: '/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/'
      path: '/bonus'
      fullPath: '/$tenantSlug/finance/bonus'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/finance/_layout/cost/': {
      id: '/_authenticated/$tenantSlug/_layout/finance/_layout/cost/'
      path: '/cost'
      fullPath: '/$tenantSlug/finance/cost'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/': {
      id: '/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/'
      path: '/penalty'
      fullPath: '/$tenantSlug/finance/penalty'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/': {
      id: '/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/'
      path: '/revenue'
      fullPath: '/$tenantSlug/finance/revenue'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/api-old/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/api-old/'
      path: '/api-old'
      fullPath: '/$tenantSlug/log/api-old'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/api/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/api/'
      path: '/api'
      fullPath: '/$tenantSlug/log/api'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutApiIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/click/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/click/'
      path: '/click'
      fullPath: '/$tenantSlug/log/click'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutClickIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/conversion/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/conversion/'
      path: '/conversion'
      fullPath: '/$tenantSlug/log/conversion'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutConversionIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/lead/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/lead/'
      path: '/lead'
      fullPath: '/$tenantSlug/log/lead'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutLeadIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/'
      path: '/pingtree'
      fullPath: '/$tenantSlug/log/pingtree'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/structure/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/structure/'
      path: '/structure'
      fullPath: '/$tenantSlug/log/structure'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutStructureIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/'
      path: '/'
      fullPath: '/$tenantSlug/log/tracking/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/validation/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/validation/'
      path: '/validation'
      fullPath: '/$tenantSlug/log/validation'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutValidationIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/'
      path: '/'
      fullPath: '/$tenantSlug/report/advertiser/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/'
      path: '/'
      fullPath: '/$tenantSlug/report/affiliate/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/event/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/event/'
      path: '/event'
      fullPath: '/$tenantSlug/report/event'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutEventIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/offer/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/offer/'
      path: '/'
      fullPath: '/$tenantSlug/report/offer/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/performance/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/performance/'
      path: '/performance'
      fullPath: '/$tenantSlug/report/performance'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/ping/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/ping/'
      path: '/ping'
      fullPath: '/$tenantSlug/report/ping'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/'
      path: '/'
      fullPath: '/$tenantSlug/report/pingtree/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/transaction/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/transaction/'
      path: '/transaction'
      fullPath: '/$tenantSlug/report/transaction'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/_layout/field/': {
      id: '/_authenticated/$tenantSlug/_layout/setting/_layout/field/'
      path: '/field'
      fullPath: '/$tenantSlug/setting/field'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/setting/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/setting/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/_layout/plan/': {
      id: '/_authenticated/$tenantSlug/_layout/setting/_layout/plan/'
      path: '/plan'
      fullPath: '/$tenantSlug/setting/plan'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/_layout/tag/': {
      id: '/_authenticated/$tenantSlug/_layout/setting/_layout/tag/'
      path: '/tag'
      fullPath: '/$tenantSlug/setting/tag'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutTagIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/': {
      id: '/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/'
      path: '/tracking'
      fullPath: '/$tenantSlug/setting/tracking'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/setting/_layout/user/': {
      id: '/_authenticated/$tenantSlug/_layout/setting/_layout/user/'
      path: '/user'
      fullPath: '/$tenantSlug/setting/user'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutUserIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/'
      path: '/'
      fullPath: '/$tenantSlug/tool/design/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/'
      path: '/'
      fullPath: '/$tenantSlug/tool/scenario/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/'
      path: '/'
      fullPath: '/$tenantSlug/tool/structure/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/'
      path: '/'
      fullPath: '/$tenantSlug/tool/tracking/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/'
      path: '/'
      fullPath: '/$tenantSlug/tool/validation/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId'
      path: '/detail/$offerId'
      fullPath: '/$tenantSlug/offer/detail/$offerId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout'
      path: '/detail/$offerId'
      fullPath: '/$tenantSlug/offer/detail/$offerId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId'
      path: '/edit/$offerId'
      fullPath: '/$tenantSlug/offer/edit/$offerId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout'
      path: '/edit/$offerId'
      fullPath: '/$tenantSlug/offer/edit/$offerId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/'
      path: '/request/offer'
      fullPath: '/$tenantSlug/affiliate/request/offer'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/'
      path: '/request/payout'
      fullPath: '/$tenantSlug/affiliate/request/payout'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/'
      path: '/'
      fullPath: '/$tenantSlug/offer/detail/$offerId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/'
      path: '/'
      fullPath: '/$tenantSlug/offer/edit/$offerId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form'
      path: '/form'
      fullPath: '/$tenantSlug/tool/design/form'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout'
      path: '/form'
      fullPath: '/$tenantSlug/tool/design/form'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration'
      path: '/integration'
      fullPath: '/$tenantSlug/tool/scenario/integration'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout'
      path: '/integration'
      fullPath: '/$tenantSlug/tool/scenario/integration'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed'
      path: '/feed'
      fullPath: '/$tenantSlug/tool/structure/feed'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout'
      path: '/feed'
      fullPath: '/$tenantSlug/tool/structure/feed'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead'
      path: '/lead'
      fullPath: '/$tenantSlug/tool/structure/lead'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout'
      path: '/lead'
      fullPath: '/$tenantSlug/tool/structure/lead'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user'
      path: '/user'
      fullPath: '/$tenantSlug/tool/structure/user'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout'
      path: '/user'
      fullPath: '/$tenantSlug/tool/structure/user'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback'
      path: '/s2s-postback'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout'
      path: '/s2s-postback'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api'
      path: '/tracking-api'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout'
      path: '/tracking-api'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId'
      path: '/$scenarioId'
      fullPath: '/$tenantSlug/tool/validation/$scenarioId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout'
      path: '/$scenarioId'
      fullPath: '/$tenantSlug/tool/validation/$scenarioId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/'
      path: '/entry'
      fullPath: '/$tenantSlug/advertiser/request/entry'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/': {
      id: '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/'
      path: '/payout'
      fullPath: '/$tenantSlug/advertiser/request/payout'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/': {
      id: '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/'
      path: '/$commissionGroupId'
      fullPath: '/$tenantSlug/affiliate/commission/$commissionGroupId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/'
      path: '/s2s-postback-steps'
      fullPath: '/$tenantSlug/log/tracking/s2s-postback-steps'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/'
      path: '/s2s-postback'
      fullPath: '/$tenantSlug/log/tracking/s2s-postback'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/'
      path: '/to'
      fullPath: '/$tenantSlug/log/tracking/to'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/'
      path: '/tracking-api-steps'
      fullPath: '/$tenantSlug/log/tracking/tracking-api-steps'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/': {
      id: '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/'
      path: '/tracking-api'
      fullPath: '/$tenantSlug/log/tracking/tracking-api'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/'
      path: '/$userId'
      fullPath: '/$tenantSlug/report/advertiser/$userId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/'
      path: '/$userId'
      fullPath: '/$tenantSlug/report/affiliate/$userId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/'
      path: '/$offerId'
      fullPath: '/$tenantSlug/report/offer/$offerId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/': {
      id: '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/'
      path: '/$pingtreeId'
      fullPath: '/$tenantSlug/report/pingtree/$pingtreeId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/'
      path: '/'
      fullPath: '/$tenantSlug/tool/design/form/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/'
      path: '/funnel'
      fullPath: '/$tenantSlug/tool/design/funnel'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/'
      path: '/screen'
      fullPath: '/$tenantSlug/tool/design/screen'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/'
      path: '/'
      fullPath: '/$tenantSlug/tool/scenario/integration/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/'
      path: '/'
      fullPath: '/$tenantSlug/tool/structure/feed/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/'
      path: '/'
      fullPath: '/$tenantSlug/tool/structure/lead/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/'
      path: '/'
      fullPath: '/$tenantSlug/tool/structure/user/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/'
      path: '/'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/'
      path: '/'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/'
      path: '/'
      fullPath: '/$tenantSlug/tool/validation/$scenarioId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/'
      path: '/api'
      fullPath: '/$tenantSlug/offer/detail/$offerId/api'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/'
      path: '/form'
      fullPath: '/$tenantSlug/offer/detail/$offerId/form'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/'
      path: '/link'
      fullPath: '/$tenantSlug/offer/detail/$offerId/link'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/'
      path: '/api'
      fullPath: '/$tenantSlug/offer/edit/$offerId/api'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/'
      path: '/filter'
      fullPath: '/$tenantSlug/offer/edit/$offerId/filter'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/'
      path: '/form'
      fullPath: '/$tenantSlug/offer/edit/$offerId/form'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/offer/edit/$offerId/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/'
      path: '/link'
      fullPath: '/$tenantSlug/offer/edit/$offerId/link'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/': {
      id: '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/'
      path: '/pingtree'
      fullPath: '/$tenantSlug/offer/edit/$offerId/pingtree'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId'
      path: '/$formId'
      fullPath: '/$tenantSlug/tool/design/form/$formId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout'
      path: '/$formId'
      fullPath: '/$tenantSlug/tool/design/form/$formId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId'
      path: '/$integrationId'
      fullPath: '/$tenantSlug/tool/scenario/integration/$integrationId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout'
      path: '/$integrationId'
      fullPath: '/$tenantSlug/tool/scenario/integration/$integrationId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId'
      path: '/$formStructureId'
      fullPath: '/$tenantSlug/tool/structure/feed/$formStructureId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout'
      path: '/$formStructureId'
      fullPath: '/$tenantSlug/tool/structure/feed/$formStructureId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId'
      path: '/$formStructureId'
      fullPath: '/$tenantSlug/tool/structure/lead/$formStructureId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout'
      path: '/$formStructureId'
      fullPath: '/$tenantSlug/tool/structure/lead/$formStructureId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId'
      path: '/$formStructureId'
      fullPath: '/$tenantSlug/tool/structure/user/$formStructureId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout'
      path: '/$formStructureId'
      fullPath: '/$tenantSlug/tool/structure/user/$formStructureId'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id'
      path: '/$id'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback/$id'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout'
      path: '/$id'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback/$id'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id'
      path: '/$id'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api/$id'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout'
      path: '/$id'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api/$id'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRoute
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/'
      path: '/'
      fullPath: '/$tenantSlug/tool/design/form/$formId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/'
      path: '/'
      fullPath: '/$tenantSlug/tool/scenario/integration/$integrationId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/'
      path: '/'
      fullPath: '/$tenantSlug/tool/structure/feed/$formStructureId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/'
      path: '/'
      fullPath: '/$tenantSlug/tool/structure/lead/$formStructureId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/'
      path: '/'
      fullPath: '/$tenantSlug/tool/structure/user/$formStructureId/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/'
      path: '/'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback/$id/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/'
      path: '/'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api/$id/'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/'
      path: '/editor'
      fullPath: '/$tenantSlug/tool/validation/$scenarioId/editor'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/validation/$scenarioId/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/design/form/$formId/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/'
      path: '/preview'
      fullPath: '/$tenantSlug/tool/design/form/$formId/preview'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/'
      path: '/editor-old'
      fullPath: '/$tenantSlug/tool/scenario/integration/$integrationId/editor-old'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/'
      path: '/editor'
      fullPath: '/$tenantSlug/tool/scenario/integration/$integrationId/editor'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/scenario/integration/$integrationId/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/'
      path: '/editor-old'
      fullPath: '/$tenantSlug/tool/structure/feed/$formStructureId/editor-old'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/structure/feed/$formStructureId/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/'
      path: '/structure'
      fullPath: '/$tenantSlug/tool/structure/feed/$formStructureId/structure'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/'
      path: '/editor-old'
      fullPath: '/$tenantSlug/tool/structure/lead/$formStructureId/editor-old'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/structure/lead/$formStructureId/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/'
      path: '/structure'
      fullPath: '/$tenantSlug/tool/structure/lead/$formStructureId/structure'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/'
      path: '/editor-old'
      fullPath: '/$tenantSlug/tool/structure/user/$formStructureId/editor-old'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/structure/user/$formStructureId/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/'
      path: '/structure'
      fullPath: '/$tenantSlug/tool/structure/user/$formStructureId/structure'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/'
      path: '/editor-old'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback/$id/editor-old'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/'
      path: '/editor'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback/$id/editor'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/tracking/s2s-postback/$id/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/'
      path: '/editor-old'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api/$id/editor-old'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/'
      path: '/editor'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api/$id/editor'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutImport
    }
    '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/': {
      id: '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/'
      path: '/general'
      fullPath: '/$tenantSlug/tool/tracking/tracking-api/$id/general'
      preLoaderRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexImport
      parentRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute
}

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteChildren: AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute,
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute,
  }

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteChildren {
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute
}

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteChildren: AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute,
  }

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteWithChildren =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteWithChildren
  AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute
  AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute
}

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteChildren: AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute,
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteWithChildren,
    AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute,
    AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute,
  }

const AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutAdvertiserRouteChildren {
  AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteWithChildren
}

const AuthenticatedTenantSlugLayoutAdvertiserRouteChildren: AuthenticatedTenantSlugLayoutAdvertiserRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAdvertiserLayoutRoute:
      AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutAdvertiserRouteWithChildren =
  AuthenticatedTenantSlugLayoutAdvertiserRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAdvertiserRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute
}

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteChildren: AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteChildren {
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute
}

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteChildren: AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute,
  }

const AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteWithChildren =
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutAffiliateLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute
  AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteWithChildren
  AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute
  AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute
}

const AuthenticatedTenantSlugLayoutAffiliateLayoutRouteChildren: AuthenticatedTenantSlugLayoutAffiliateLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute,
    AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteWithChildren,
    AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute,
    AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute,
  }

const AuthenticatedTenantSlugLayoutAffiliateLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutAffiliateLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAffiliateLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutAffiliateRouteChildren {
  AuthenticatedTenantSlugLayoutAffiliateLayoutRoute: typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRouteWithChildren
}

const AuthenticatedTenantSlugLayoutAffiliateRouteChildren: AuthenticatedTenantSlugLayoutAffiliateRouteChildren =
  {
    AuthenticatedTenantSlugLayoutAffiliateLayoutRoute:
      AuthenticatedTenantSlugLayoutAffiliateLayoutRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutAffiliateRouteWithChildren =
  AuthenticatedTenantSlugLayoutAffiliateRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutAffiliateRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutFinanceLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute
  AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute
  AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute
  AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute
}

const AuthenticatedTenantSlugLayoutFinanceLayoutRouteChildren: AuthenticatedTenantSlugLayoutFinanceLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute:
      AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute,
    AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute:
      AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute,
    AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute:
      AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute,
    AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute:
      AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute,
  }

const AuthenticatedTenantSlugLayoutFinanceLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutFinanceLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutFinanceLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutFinanceRouteChildren {
  AuthenticatedTenantSlugLayoutFinanceLayoutRoute: typeof AuthenticatedTenantSlugLayoutFinanceLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutFinanceIndexRoute: typeof AuthenticatedTenantSlugLayoutFinanceIndexRoute
}

const AuthenticatedTenantSlugLayoutFinanceRouteChildren: AuthenticatedTenantSlugLayoutFinanceRouteChildren =
  {
    AuthenticatedTenantSlugLayoutFinanceLayoutRoute:
      AuthenticatedTenantSlugLayoutFinanceLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutFinanceIndexRoute:
      AuthenticatedTenantSlugLayoutFinanceIndexRoute,
  }

const AuthenticatedTenantSlugLayoutFinanceRouteWithChildren =
  AuthenticatedTenantSlugLayoutFinanceRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutFinanceRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute
}

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteChildren: AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute,
  }

const AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteChildren {
  AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute
}

const AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteChildren: AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteChildren =
  {
    AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute,
  }

const AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteWithChildren =
  AuthenticatedTenantSlugLayoutLogLayoutTrackingRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutLogLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutLogLayoutTrackingRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteWithChildren
  AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute
  AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute
}

const AuthenticatedTenantSlugLayoutLogLayoutRouteChildren: AuthenticatedTenantSlugLayoutLogLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutLogLayoutTrackingRoute:
      AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteWithChildren,
    AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute,
    AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute:
      AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute,
  }

const AuthenticatedTenantSlugLayoutLogLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutLogLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutLogLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutLogRouteChildren {
  AuthenticatedTenantSlugLayoutLogLayoutRoute: typeof AuthenticatedTenantSlugLayoutLogLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutLogIndexRoute: typeof AuthenticatedTenantSlugLayoutLogIndexRoute
}

const AuthenticatedTenantSlugLayoutLogRouteChildren: AuthenticatedTenantSlugLayoutLogRouteChildren =
  {
    AuthenticatedTenantSlugLayoutLogLayoutRoute:
      AuthenticatedTenantSlugLayoutLogLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutLogIndexRoute:
      AuthenticatedTenantSlugLayoutLogIndexRoute,
  }

const AuthenticatedTenantSlugLayoutLogRouteWithChildren =
  AuthenticatedTenantSlugLayoutLogRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutLogRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute
}

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute,
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute,
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute,
  }

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteChildren {
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute
}

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteChildren: AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute
}

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute,
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute,
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute,
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute,
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute,
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute,
  }

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteChildren {
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute
}

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteChildren: AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutOfferLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteWithChildren
  AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutOfferLayoutRouteChildren: AuthenticatedTenantSlugLayoutOfferLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteWithChildren,
    AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutOfferLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutOfferLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutOfferLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutOfferRouteChildren {
  AuthenticatedTenantSlugLayoutOfferLayoutRoute: typeof AuthenticatedTenantSlugLayoutOfferLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutOfferIndexRoute: typeof AuthenticatedTenantSlugLayoutOfferIndexRoute
}

const AuthenticatedTenantSlugLayoutOfferRouteChildren: AuthenticatedTenantSlugLayoutOfferRouteChildren =
  {
    AuthenticatedTenantSlugLayoutOfferLayoutRoute:
      AuthenticatedTenantSlugLayoutOfferLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutOfferIndexRoute:
      AuthenticatedTenantSlugLayoutOfferIndexRoute,
  }

const AuthenticatedTenantSlugLayoutOfferRouteWithChildren =
  AuthenticatedTenantSlugLayoutOfferRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutOfferRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutOfferRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutOfferRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutOfferRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRoute:
      AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutOfferRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutOfferRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutOfferRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRoute:
      AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutAffiliateRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutOfferRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutOfferRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutPingtreeRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteWithChildren
  AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute
  AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute
  AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute
  AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute
}

const AuthenticatedTenantSlugLayoutReportLayoutRouteChildren: AuthenticatedTenantSlugLayoutReportLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutAffiliateRoute:
      AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutOfferRoute:
      AuthenticatedTenantSlugLayoutReportLayoutOfferRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutPingtreeRoute:
      AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute,
    AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute,
    AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute,
    AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute:
      AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutReportRouteChildren {
  AuthenticatedTenantSlugLayoutReportLayoutRoute: typeof AuthenticatedTenantSlugLayoutReportLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutReportIndexRoute: typeof AuthenticatedTenantSlugLayoutReportIndexRoute
}

const AuthenticatedTenantSlugLayoutReportRouteChildren: AuthenticatedTenantSlugLayoutReportRouteChildren =
  {
    AuthenticatedTenantSlugLayoutReportLayoutRoute:
      AuthenticatedTenantSlugLayoutReportLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportIndexRoute:
      AuthenticatedTenantSlugLayoutReportIndexRoute,
  }

const AuthenticatedTenantSlugLayoutReportRouteWithChildren =
  AuthenticatedTenantSlugLayoutReportRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutReportRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutSettingLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute
  AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute
  AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute
  AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute
  AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute
  AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute
}

const AuthenticatedTenantSlugLayoutSettingLayoutRouteChildren: AuthenticatedTenantSlugLayoutSettingLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute:
      AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute,
    AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute,
    AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute:
      AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute,
    AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute:
      AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute,
    AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute:
      AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute,
    AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute:
      AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute,
  }

const AuthenticatedTenantSlugLayoutSettingLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutSettingLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutSettingLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutSettingRouteChildren {
  AuthenticatedTenantSlugLayoutSettingLayoutRoute: typeof AuthenticatedTenantSlugLayoutSettingLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutSettingIndexRoute: typeof AuthenticatedTenantSlugLayoutSettingIndexRoute
}

const AuthenticatedTenantSlugLayoutSettingRouteChildren: AuthenticatedTenantSlugLayoutSettingRouteChildren =
  {
    AuthenticatedTenantSlugLayoutSettingLayoutRoute:
      AuthenticatedTenantSlugLayoutSettingLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutSettingIndexRoute:
      AuthenticatedTenantSlugLayoutSettingIndexRoute,
  }

const AuthenticatedTenantSlugLayoutSettingRouteWithChildren =
  AuthenticatedTenantSlugLayoutSettingRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutSettingRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutDesignRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutDesignRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutDesignRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutDesignRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutDesignRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutDesignRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutScenarioRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutStructureRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutStructureRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutStructureRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutStructureRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutStructureRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutStructureRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutTrackingRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute,
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutValidationRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute
}

const AuthenticatedTenantSlugLayoutToolLayoutValidationRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutValidationRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolLayoutValidationRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutValidationRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutValidationRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutDesignRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutDesignRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutScenarioRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutStructureRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutStructureRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutTrackingRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteWithChildren
  AuthenticatedTenantSlugLayoutToolLayoutValidationRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutValidationRouteWithChildren
}

const AuthenticatedTenantSlugLayoutToolLayoutRouteChildren: AuthenticatedTenantSlugLayoutToolLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutDesignRoute:
      AuthenticatedTenantSlugLayoutToolLayoutDesignRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutScenarioRoute:
      AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutStructureRoute:
      AuthenticatedTenantSlugLayoutToolLayoutStructureRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutTrackingRoute:
      AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolLayoutValidationRoute:
      AuthenticatedTenantSlugLayoutToolLayoutValidationRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutToolLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutToolRouteChildren {
  AuthenticatedTenantSlugLayoutToolLayoutRoute: typeof AuthenticatedTenantSlugLayoutToolLayoutRouteWithChildren
  AuthenticatedTenantSlugLayoutToolIndexRoute: typeof AuthenticatedTenantSlugLayoutToolIndexRoute
}

const AuthenticatedTenantSlugLayoutToolRouteChildren: AuthenticatedTenantSlugLayoutToolRouteChildren =
  {
    AuthenticatedTenantSlugLayoutToolLayoutRoute:
      AuthenticatedTenantSlugLayoutToolLayoutRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolIndexRoute:
      AuthenticatedTenantSlugLayoutToolIndexRoute,
  }

const AuthenticatedTenantSlugLayoutToolRouteWithChildren =
  AuthenticatedTenantSlugLayoutToolRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutToolRouteChildren,
  )

interface AuthenticatedTenantSlugLayoutRouteChildren {
  AuthenticatedTenantSlugLayoutIndexRoute: typeof AuthenticatedTenantSlugLayoutIndexRoute
  AuthenticatedTenantSlugLayoutAdvertiserRoute: typeof AuthenticatedTenantSlugLayoutAdvertiserRouteWithChildren
  AuthenticatedTenantSlugLayoutAffiliateRoute: typeof AuthenticatedTenantSlugLayoutAffiliateRouteWithChildren
  AuthenticatedTenantSlugLayoutFinanceRoute: typeof AuthenticatedTenantSlugLayoutFinanceRouteWithChildren
  AuthenticatedTenantSlugLayoutLogRoute: typeof AuthenticatedTenantSlugLayoutLogRouteWithChildren
  AuthenticatedTenantSlugLayoutOfferRoute: typeof AuthenticatedTenantSlugLayoutOfferRouteWithChildren
  AuthenticatedTenantSlugLayoutReportRoute: typeof AuthenticatedTenantSlugLayoutReportRouteWithChildren
  AuthenticatedTenantSlugLayoutSettingRoute: typeof AuthenticatedTenantSlugLayoutSettingRouteWithChildren
  AuthenticatedTenantSlugLayoutToolRoute: typeof AuthenticatedTenantSlugLayoutToolRouteWithChildren
}

const AuthenticatedTenantSlugLayoutRouteChildren: AuthenticatedTenantSlugLayoutRouteChildren =
  {
    AuthenticatedTenantSlugLayoutIndexRoute:
      AuthenticatedTenantSlugLayoutIndexRoute,
    AuthenticatedTenantSlugLayoutAdvertiserRoute:
      AuthenticatedTenantSlugLayoutAdvertiserRouteWithChildren,
    AuthenticatedTenantSlugLayoutAffiliateRoute:
      AuthenticatedTenantSlugLayoutAffiliateRouteWithChildren,
    AuthenticatedTenantSlugLayoutFinanceRoute:
      AuthenticatedTenantSlugLayoutFinanceRouteWithChildren,
    AuthenticatedTenantSlugLayoutLogRoute:
      AuthenticatedTenantSlugLayoutLogRouteWithChildren,
    AuthenticatedTenantSlugLayoutOfferRoute:
      AuthenticatedTenantSlugLayoutOfferRouteWithChildren,
    AuthenticatedTenantSlugLayoutReportRoute:
      AuthenticatedTenantSlugLayoutReportRouteWithChildren,
    AuthenticatedTenantSlugLayoutSettingRoute:
      AuthenticatedTenantSlugLayoutSettingRouteWithChildren,
    AuthenticatedTenantSlugLayoutToolRoute:
      AuthenticatedTenantSlugLayoutToolRouteWithChildren,
  }

const AuthenticatedTenantSlugLayoutRouteWithChildren =
  AuthenticatedTenantSlugLayoutRoute._addFileChildren(
    AuthenticatedTenantSlugLayoutRouteChildren,
  )

interface AuthenticatedTenantSlugRouteChildren {
  AuthenticatedTenantSlugLayoutRoute: typeof AuthenticatedTenantSlugLayoutRouteWithChildren
}

const AuthenticatedTenantSlugRouteChildren: AuthenticatedTenantSlugRouteChildren =
  {
    AuthenticatedTenantSlugLayoutRoute:
      AuthenticatedTenantSlugLayoutRouteWithChildren,
  }

const AuthenticatedTenantSlugRouteWithChildren =
  AuthenticatedTenantSlugRoute._addFileChildren(
    AuthenticatedTenantSlugRouteChildren,
  )

interface AuthenticatedAccountLayoutRouteChildren {
  AuthenticatedAccountLayoutIndexRoute: typeof AuthenticatedAccountLayoutIndexRoute
  AuthenticatedAccountLayoutCatalogIndexRoute: typeof AuthenticatedAccountLayoutCatalogIndexRoute
  AuthenticatedAccountLayoutPartnersIndexRoute: typeof AuthenticatedAccountLayoutPartnersIndexRoute
  AuthenticatedAccountLayoutSettingsIndexRoute: typeof AuthenticatedAccountLayoutSettingsIndexRoute
}

const AuthenticatedAccountLayoutRouteChildren: AuthenticatedAccountLayoutRouteChildren =
  {
    AuthenticatedAccountLayoutIndexRoute: AuthenticatedAccountLayoutIndexRoute,
    AuthenticatedAccountLayoutCatalogIndexRoute:
      AuthenticatedAccountLayoutCatalogIndexRoute,
    AuthenticatedAccountLayoutPartnersIndexRoute:
      AuthenticatedAccountLayoutPartnersIndexRoute,
    AuthenticatedAccountLayoutSettingsIndexRoute:
      AuthenticatedAccountLayoutSettingsIndexRoute,
  }

const AuthenticatedAccountLayoutRouteWithChildren =
  AuthenticatedAccountLayoutRoute._addFileChildren(
    AuthenticatedAccountLayoutRouteChildren,
  )

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountLayoutRoute: typeof AuthenticatedAccountLayoutRouteWithChildren
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountLayoutRoute: AuthenticatedAccountLayoutRouteWithChildren,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTenantSlugRoute: typeof AuthenticatedTenantSlugRouteWithChildren
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTenantSlugRoute: AuthenticatedTenantSlugRouteWithChildren,
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuthLayoutRouteChildren {
  AuthLayoutChangePasswordIndexRoute: typeof AuthLayoutChangePasswordIndexRoute
  AuthLayoutForgotPasswordIndexRoute: typeof AuthLayoutForgotPasswordIndexRoute
  AuthLayoutLoginIndexRoute: typeof AuthLayoutLoginIndexRoute
  AuthLayoutRegistrationIndexRoute: typeof AuthLayoutRegistrationIndexRoute
  AuthLayoutActivateUserIdEmailHashIndexRoute: typeof AuthLayoutActivateUserIdEmailHashIndexRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutChangePasswordIndexRoute: AuthLayoutChangePasswordIndexRoute,
  AuthLayoutForgotPasswordIndexRoute: AuthLayoutForgotPasswordIndexRoute,
  AuthLayoutLoginIndexRoute: AuthLayoutLoginIndexRoute,
  AuthLayoutRegistrationIndexRoute: AuthLayoutRegistrationIndexRoute,
  AuthLayoutActivateUserIdEmailHashIndexRoute:
    AuthLayoutActivateUserIdEmailHashIndexRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface TenantSlugAuthLayoutRouteChildren {
  TenantSlugAuthLayoutChangePasswordIndexRoute: typeof TenantSlugAuthLayoutChangePasswordIndexRoute
  TenantSlugAuthLayoutConfirmRegistrationIndexRoute: typeof TenantSlugAuthLayoutConfirmRegistrationIndexRoute
  TenantSlugAuthLayoutForgotPasswordIndexRoute: typeof TenantSlugAuthLayoutForgotPasswordIndexRoute
  TenantSlugAuthLayoutLoginIndexRoute: typeof TenantSlugAuthLayoutLoginIndexRoute
  TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute: typeof TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute
  TenantSlugAuthLayoutRegistrationIndexRoute: typeof TenantSlugAuthLayoutRegistrationIndexRoute
  TenantSlugAuthLayoutAcceptInvitationIdHashRoute: typeof TenantSlugAuthLayoutAcceptInvitationIdHashRoute
  TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute: typeof TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute
}

const TenantSlugAuthLayoutRouteChildren: TenantSlugAuthLayoutRouteChildren = {
  TenantSlugAuthLayoutChangePasswordIndexRoute:
    TenantSlugAuthLayoutChangePasswordIndexRoute,
  TenantSlugAuthLayoutConfirmRegistrationIndexRoute:
    TenantSlugAuthLayoutConfirmRegistrationIndexRoute,
  TenantSlugAuthLayoutForgotPasswordIndexRoute:
    TenantSlugAuthLayoutForgotPasswordIndexRoute,
  TenantSlugAuthLayoutLoginIndexRoute: TenantSlugAuthLayoutLoginIndexRoute,
  TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute:
    TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute,
  TenantSlugAuthLayoutRegistrationIndexRoute:
    TenantSlugAuthLayoutRegistrationIndexRoute,
  TenantSlugAuthLayoutAcceptInvitationIdHashRoute:
    TenantSlugAuthLayoutAcceptInvitationIdHashRoute,
  TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute:
    TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute,
}

const TenantSlugAuthLayoutRouteWithChildren =
  TenantSlugAuthLayoutRoute._addFileChildren(TenantSlugAuthLayoutRouteChildren)

interface TenantSlugAuthRouteChildren {
  TenantSlugAuthLayoutRoute: typeof TenantSlugAuthLayoutRouteWithChildren
}

const TenantSlugAuthRouteChildren: TenantSlugAuthRouteChildren = {
  TenantSlugAuthLayoutRoute: TenantSlugAuthLayoutRouteWithChildren,
}

const TenantSlugAuthRouteWithChildren = TenantSlugAuthRoute._addFileChildren(
  TenantSlugAuthRouteChildren,
)

interface TenantSlugProcessesLayoutRouteChildren {
  TenantSlugProcessesLayoutProcessIdIndexRoute: typeof TenantSlugProcessesLayoutProcessIdIndexRoute
}

const TenantSlugProcessesLayoutRouteChildren: TenantSlugProcessesLayoutRouteChildren =
  {
    TenantSlugProcessesLayoutProcessIdIndexRoute:
      TenantSlugProcessesLayoutProcessIdIndexRoute,
  }

const TenantSlugProcessesLayoutRouteWithChildren =
  TenantSlugProcessesLayoutRoute._addFileChildren(
    TenantSlugProcessesLayoutRouteChildren,
  )

interface TenantSlugProcessesRouteChildren {
  TenantSlugProcessesLayoutRoute: typeof TenantSlugProcessesLayoutRouteWithChildren
}

const TenantSlugProcessesRouteChildren: TenantSlugProcessesRouteChildren = {
  TenantSlugProcessesLayoutRoute: TenantSlugProcessesLayoutRouteWithChildren,
}

const TenantSlugProcessesRouteWithChildren =
  TenantSlugProcessesRoute._addFileChildren(TenantSlugProcessesRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/auth': typeof AuthLayoutRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/$tenantSlug/auth': typeof TenantSlugAuthLayoutRouteWithChildren
  '/$tenantSlug/processes': typeof TenantSlugProcessesLayoutRouteWithChildren
  '/$tenantSlug': typeof AuthenticatedTenantSlugLayoutRouteWithChildren
  '/account': typeof AuthenticatedAccountLayoutRouteWithChildren
  '/$tenantSlug/confirm-deletion': typeof TenantSlugConfirmDeletionIndexRoute
  '/$tenantSlug/no-access': typeof TenantSlugNoAccessIndexRoute
  '/$tenantSlug/': typeof AuthenticatedTenantSlugLayoutIndexRoute
  '/account/': typeof AuthenticatedAccountLayoutIndexRoute
  '/auth/change-password': typeof AuthLayoutChangePasswordIndexRoute
  '/auth/forgot-password': typeof AuthLayoutForgotPasswordIndexRoute
  '/auth/login': typeof AuthLayoutLoginIndexRoute
  '/auth/registration': typeof AuthLayoutRegistrationIndexRoute
  '/$tenantSlug/advertiser': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteWithChildren
  '/$tenantSlug/affiliate': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRouteWithChildren
  '/$tenantSlug/finance': typeof AuthenticatedTenantSlugLayoutFinanceLayoutRouteWithChildren
  '/$tenantSlug/log': typeof AuthenticatedTenantSlugLayoutLogLayoutRouteWithChildren
  '/$tenantSlug/offer': typeof AuthenticatedTenantSlugLayoutOfferLayoutRouteWithChildren
  '/$tenantSlug/report': typeof AuthenticatedTenantSlugLayoutReportLayoutRouteWithChildren
  '/$tenantSlug/setting': typeof AuthenticatedTenantSlugLayoutSettingLayoutRouteWithChildren
  '/$tenantSlug/tool': typeof AuthenticatedTenantSlugLayoutToolLayoutRouteWithChildren
  '/$tenantSlug/auth/change-password': typeof TenantSlugAuthLayoutChangePasswordIndexRoute
  '/$tenantSlug/auth/confirm-registration': typeof TenantSlugAuthLayoutConfirmRegistrationIndexRoute
  '/$tenantSlug/auth/forgot-password': typeof TenantSlugAuthLayoutForgotPasswordIndexRoute
  '/$tenantSlug/auth/login': typeof TenantSlugAuthLayoutLoginIndexRoute
  '/$tenantSlug/auth/registration-advertiser': typeof TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute
  '/$tenantSlug/auth/registration': typeof TenantSlugAuthLayoutRegistrationIndexRoute
  '/$tenantSlug/processes/$processId': typeof TenantSlugProcessesLayoutProcessIdIndexRoute
  '/$tenantSlug/finance/': typeof AuthenticatedTenantSlugLayoutFinanceIndexRoute
  '/$tenantSlug/log/': typeof AuthenticatedTenantSlugLayoutLogIndexRoute
  '/$tenantSlug/offer/': typeof AuthenticatedTenantSlugLayoutOfferIndexRoute
  '/$tenantSlug/report/': typeof AuthenticatedTenantSlugLayoutReportIndexRoute
  '/$tenantSlug/setting/': typeof AuthenticatedTenantSlugLayoutSettingIndexRoute
  '/$tenantSlug/tool/': typeof AuthenticatedTenantSlugLayoutToolIndexRoute
  '/account/catalog': typeof AuthenticatedAccountLayoutCatalogIndexRoute
  '/account/partners': typeof AuthenticatedAccountLayoutPartnersIndexRoute
  '/account/settings': typeof AuthenticatedAccountLayoutSettingsIndexRoute
  '/$tenantSlug/auth/accept-invitation/$id/$hash': typeof TenantSlugAuthLayoutAcceptInvitationIdHashRoute
  '/$tenantSlug/advertiser/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute
  '/$tenantSlug/affiliate/': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute
  '/auth/activate/$userId/$emailHash': typeof AuthLayoutActivateUserIdEmailHashIndexRoute
  '/$tenantSlug/advertiser/request': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteWithChildren
  '/$tenantSlug/affiliate/commission': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteWithChildren
  '/$tenantSlug/log/tracking': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteWithChildren
  '/$tenantSlug/report/advertiser': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteWithChildren
  '/$tenantSlug/report/affiliate': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteWithChildren
  '/$tenantSlug/report/offer': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteWithChildren
  '/$tenantSlug/report/pingtree': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteWithChildren
  '/$tenantSlug/tool/design': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteWithChildren
  '/$tenantSlug/tool/scenario': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteWithChildren
  '/$tenantSlug/tool/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteWithChildren
  '/$tenantSlug/tool/tracking': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteWithChildren
  '/$tenantSlug/tool/validation': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteWithChildren
  '/$tenantSlug/auth/activate/$userId/$emailHash': typeof TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute
  '/$tenantSlug/advertiser/commission': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute
  '/$tenantSlug/advertiser/request/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute
  '/$tenantSlug/advertiser/transaction': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute
  '/$tenantSlug/affiliate/commission/': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute
  '/$tenantSlug/finance/bonus': typeof AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute
  '/$tenantSlug/finance/cost': typeof AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute
  '/$tenantSlug/finance/penalty': typeof AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute
  '/$tenantSlug/finance/revenue': typeof AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute
  '/$tenantSlug/log/api-old': typeof AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute
  '/$tenantSlug/log/api': typeof AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute
  '/$tenantSlug/log/click': typeof AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute
  '/$tenantSlug/log/conversion': typeof AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute
  '/$tenantSlug/log/lead': typeof AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute
  '/$tenantSlug/log/pingtree': typeof AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute
  '/$tenantSlug/log/structure': typeof AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute
  '/$tenantSlug/log/tracking/': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute
  '/$tenantSlug/log/validation': typeof AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute
  '/$tenantSlug/report/advertiser/': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute
  '/$tenantSlug/report/affiliate/': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute
  '/$tenantSlug/report/event': typeof AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute
  '/$tenantSlug/report/offer/': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute
  '/$tenantSlug/report/performance': typeof AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute
  '/$tenantSlug/report/ping': typeof AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute
  '/$tenantSlug/report/pingtree/': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute
  '/$tenantSlug/report/transaction': typeof AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute
  '/$tenantSlug/setting/field': typeof AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute
  '/$tenantSlug/setting/general': typeof AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute
  '/$tenantSlug/setting/plan': typeof AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute
  '/$tenantSlug/setting/tag': typeof AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute
  '/$tenantSlug/setting/tracking': typeof AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute
  '/$tenantSlug/setting/user': typeof AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute
  '/$tenantSlug/tool/design/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute
  '/$tenantSlug/tool/scenario/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute
  '/$tenantSlug/tool/structure/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute
  '/$tenantSlug/tool/tracking/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute
  '/$tenantSlug/tool/validation/': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute
  '/$tenantSlug/offer/detail/$offerId': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteWithChildren
  '/$tenantSlug/offer/edit/$offerId': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteWithChildren
  '/$tenantSlug/affiliate/request/offer': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute
  '/$tenantSlug/affiliate/request/payout': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute
  '/$tenantSlug/offer/detail/$offerId/': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute
  '/$tenantSlug/offer/edit/$offerId/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute
  '/$tenantSlug/tool/design/form': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteWithChildren
  '/$tenantSlug/tool/scenario/integration': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteWithChildren
  '/$tenantSlug/tool/structure/feed': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteWithChildren
  '/$tenantSlug/tool/structure/lead': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteWithChildren
  '/$tenantSlug/tool/structure/user': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteWithChildren
  '/$tenantSlug/tool/tracking/s2s-postback': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteWithChildren
  '/$tenantSlug/tool/tracking/tracking-api': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteWithChildren
  '/$tenantSlug/tool/validation/$scenarioId': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteWithChildren
  '/$tenantSlug/advertiser/request/entry': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute
  '/$tenantSlug/advertiser/request/payout': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute
  '/$tenantSlug/affiliate/commission/$commissionGroupId': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute
  '/$tenantSlug/log/tracking/s2s-postback-steps': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute
  '/$tenantSlug/log/tracking/s2s-postback': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute
  '/$tenantSlug/log/tracking/to': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute
  '/$tenantSlug/log/tracking/tracking-api-steps': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute
  '/$tenantSlug/log/tracking/tracking-api': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute
  '/$tenantSlug/report/advertiser/$userId': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute
  '/$tenantSlug/report/affiliate/$userId': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute
  '/$tenantSlug/report/offer/$offerId': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute
  '/$tenantSlug/report/pingtree/$pingtreeId': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute
  '/$tenantSlug/tool/design/form/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute
  '/$tenantSlug/tool/design/funnel': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute
  '/$tenantSlug/tool/design/screen': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute
  '/$tenantSlug/tool/scenario/integration/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute
  '/$tenantSlug/tool/structure/feed/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute
  '/$tenantSlug/tool/structure/lead/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute
  '/$tenantSlug/tool/structure/user/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute
  '/$tenantSlug/tool/validation/$scenarioId/': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute
  '/$tenantSlug/offer/detail/$offerId/api': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute
  '/$tenantSlug/offer/detail/$offerId/form': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute
  '/$tenantSlug/offer/detail/$offerId/link': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute
  '/$tenantSlug/offer/edit/$offerId/api': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute
  '/$tenantSlug/offer/edit/$offerId/filter': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute
  '/$tenantSlug/offer/edit/$offerId/form': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute
  '/$tenantSlug/offer/edit/$offerId/general': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute
  '/$tenantSlug/offer/edit/$offerId/link': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute
  '/$tenantSlug/offer/edit/$offerId/pingtree': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute
  '/$tenantSlug/tool/design/form/$formId': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteWithChildren
  '/$tenantSlug/tool/scenario/integration/$integrationId': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteWithChildren
  '/$tenantSlug/tool/structure/feed/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteWithChildren
  '/$tenantSlug/tool/structure/lead/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteWithChildren
  '/$tenantSlug/tool/structure/user/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteWithChildren
  '/$tenantSlug/tool/tracking/s2s-postback/$id': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteWithChildren
  '/$tenantSlug/tool/tracking/tracking-api/$id': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteWithChildren
  '/$tenantSlug/tool/design/form/$formId/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute
  '/$tenantSlug/tool/validation/$scenarioId/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/validation/$scenarioId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/design/form/$formId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/design/form/$formId/preview': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id/general': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id/general': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute
}

export interface FileRoutesByTo {
  '/auth': typeof AuthLayoutRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/$tenantSlug/auth': typeof TenantSlugAuthLayoutRouteWithChildren
  '/$tenantSlug/processes': typeof TenantSlugProcessesLayoutRouteWithChildren
  '/$tenantSlug': typeof AuthenticatedTenantSlugLayoutIndexRoute
  '/account': typeof AuthenticatedAccountLayoutIndexRoute
  '/$tenantSlug/confirm-deletion': typeof TenantSlugConfirmDeletionIndexRoute
  '/$tenantSlug/no-access': typeof TenantSlugNoAccessIndexRoute
  '/auth/change-password': typeof AuthLayoutChangePasswordIndexRoute
  '/auth/forgot-password': typeof AuthLayoutForgotPasswordIndexRoute
  '/auth/login': typeof AuthLayoutLoginIndexRoute
  '/auth/registration': typeof AuthLayoutRegistrationIndexRoute
  '/$tenantSlug/advertiser': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute
  '/$tenantSlug/affiliate': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute
  '/$tenantSlug/finance': typeof AuthenticatedTenantSlugLayoutFinanceIndexRoute
  '/$tenantSlug/log': typeof AuthenticatedTenantSlugLayoutLogIndexRoute
  '/$tenantSlug/offer': typeof AuthenticatedTenantSlugLayoutOfferIndexRoute
  '/$tenantSlug/report': typeof AuthenticatedTenantSlugLayoutReportIndexRoute
  '/$tenantSlug/setting': typeof AuthenticatedTenantSlugLayoutSettingIndexRoute
  '/$tenantSlug/tool': typeof AuthenticatedTenantSlugLayoutToolIndexRoute
  '/$tenantSlug/auth/change-password': typeof TenantSlugAuthLayoutChangePasswordIndexRoute
  '/$tenantSlug/auth/confirm-registration': typeof TenantSlugAuthLayoutConfirmRegistrationIndexRoute
  '/$tenantSlug/auth/forgot-password': typeof TenantSlugAuthLayoutForgotPasswordIndexRoute
  '/$tenantSlug/auth/login': typeof TenantSlugAuthLayoutLoginIndexRoute
  '/$tenantSlug/auth/registration-advertiser': typeof TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute
  '/$tenantSlug/auth/registration': typeof TenantSlugAuthLayoutRegistrationIndexRoute
  '/$tenantSlug/processes/$processId': typeof TenantSlugProcessesLayoutProcessIdIndexRoute
  '/account/catalog': typeof AuthenticatedAccountLayoutCatalogIndexRoute
  '/account/partners': typeof AuthenticatedAccountLayoutPartnersIndexRoute
  '/account/settings': typeof AuthenticatedAccountLayoutSettingsIndexRoute
  '/$tenantSlug/auth/accept-invitation/$id/$hash': typeof TenantSlugAuthLayoutAcceptInvitationIdHashRoute
  '/auth/activate/$userId/$emailHash': typeof AuthLayoutActivateUserIdEmailHashIndexRoute
  '/$tenantSlug/advertiser/request': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute
  '/$tenantSlug/affiliate/commission': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute
  '/$tenantSlug/log/tracking': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute
  '/$tenantSlug/report/advertiser': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute
  '/$tenantSlug/report/affiliate': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute
  '/$tenantSlug/report/offer': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute
  '/$tenantSlug/report/pingtree': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute
  '/$tenantSlug/tool/design': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute
  '/$tenantSlug/tool/scenario': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute
  '/$tenantSlug/tool/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute
  '/$tenantSlug/tool/tracking': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute
  '/$tenantSlug/tool/validation': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute
  '/$tenantSlug/auth/activate/$userId/$emailHash': typeof TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute
  '/$tenantSlug/advertiser/commission': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute
  '/$tenantSlug/advertiser/transaction': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute
  '/$tenantSlug/finance/bonus': typeof AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute
  '/$tenantSlug/finance/cost': typeof AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute
  '/$tenantSlug/finance/penalty': typeof AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute
  '/$tenantSlug/finance/revenue': typeof AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute
  '/$tenantSlug/log/api-old': typeof AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute
  '/$tenantSlug/log/api': typeof AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute
  '/$tenantSlug/log/click': typeof AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute
  '/$tenantSlug/log/conversion': typeof AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute
  '/$tenantSlug/log/lead': typeof AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute
  '/$tenantSlug/log/pingtree': typeof AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute
  '/$tenantSlug/log/structure': typeof AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute
  '/$tenantSlug/log/validation': typeof AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute
  '/$tenantSlug/report/event': typeof AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute
  '/$tenantSlug/report/performance': typeof AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute
  '/$tenantSlug/report/ping': typeof AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute
  '/$tenantSlug/report/transaction': typeof AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute
  '/$tenantSlug/setting/field': typeof AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute
  '/$tenantSlug/setting/general': typeof AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute
  '/$tenantSlug/setting/plan': typeof AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute
  '/$tenantSlug/setting/tag': typeof AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute
  '/$tenantSlug/setting/tracking': typeof AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute
  '/$tenantSlug/setting/user': typeof AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute
  '/$tenantSlug/offer/detail/$offerId': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute
  '/$tenantSlug/offer/edit/$offerId': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute
  '/$tenantSlug/affiliate/request/offer': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute
  '/$tenantSlug/affiliate/request/payout': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute
  '/$tenantSlug/tool/design/form': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute
  '/$tenantSlug/tool/scenario/integration': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute
  '/$tenantSlug/tool/structure/feed': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute
  '/$tenantSlug/tool/structure/lead': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute
  '/$tenantSlug/tool/structure/user': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute
  '/$tenantSlug/tool/validation/$scenarioId': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute
  '/$tenantSlug/advertiser/request/entry': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute
  '/$tenantSlug/advertiser/request/payout': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute
  '/$tenantSlug/affiliate/commission/$commissionGroupId': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute
  '/$tenantSlug/log/tracking/s2s-postback-steps': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute
  '/$tenantSlug/log/tracking/s2s-postback': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute
  '/$tenantSlug/log/tracking/to': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute
  '/$tenantSlug/log/tracking/tracking-api-steps': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute
  '/$tenantSlug/log/tracking/tracking-api': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute
  '/$tenantSlug/report/advertiser/$userId': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute
  '/$tenantSlug/report/affiliate/$userId': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute
  '/$tenantSlug/report/offer/$offerId': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute
  '/$tenantSlug/report/pingtree/$pingtreeId': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute
  '/$tenantSlug/tool/design/funnel': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute
  '/$tenantSlug/tool/design/screen': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute
  '/$tenantSlug/offer/detail/$offerId/api': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute
  '/$tenantSlug/offer/detail/$offerId/form': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute
  '/$tenantSlug/offer/detail/$offerId/link': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute
  '/$tenantSlug/offer/edit/$offerId/api': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute
  '/$tenantSlug/offer/edit/$offerId/filter': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute
  '/$tenantSlug/offer/edit/$offerId/form': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute
  '/$tenantSlug/offer/edit/$offerId/general': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute
  '/$tenantSlug/offer/edit/$offerId/link': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute
  '/$tenantSlug/offer/edit/$offerId/pingtree': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute
  '/$tenantSlug/tool/design/form/$formId': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute
  '/$tenantSlug/tool/validation/$scenarioId/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/validation/$scenarioId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/design/form/$formId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/design/form/$formId/preview': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/scenario/integration/$integrationId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/feed/$formStructureId/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/lead/$formStructureId/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId/general': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/structure/user/$formStructureId/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/tracking/s2s-postback/$id/general': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id/editor-old': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id/editor': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute
  '/$tenantSlug/tool/tracking/tracking-api/$id/general': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/auth/_layout': typeof AuthLayoutRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/$tenantSlug/auth': typeof TenantSlugAuthRouteWithChildren
  '/$tenantSlug/auth/_layout': typeof TenantSlugAuthLayoutRouteWithChildren
  '/$tenantSlug/processes': typeof TenantSlugProcessesRouteWithChildren
  '/$tenantSlug/processes/_layout': typeof TenantSlugProcessesLayoutRouteWithChildren
  '/_authenticated/$tenantSlug': typeof AuthenticatedTenantSlugRouteWithChildren
  '/_authenticated/$tenantSlug/_layout': typeof AuthenticatedTenantSlugLayoutRouteWithChildren
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/_authenticated/account/_layout': typeof AuthenticatedAccountLayoutRouteWithChildren
  '/$tenantSlug/confirm-deletion/': typeof TenantSlugConfirmDeletionIndexRoute
  '/$tenantSlug/no-access/': typeof TenantSlugNoAccessIndexRoute
  '/_authenticated/$tenantSlug/_layout/': typeof AuthenticatedTenantSlugLayoutIndexRoute
  '/_authenticated/account/_layout/': typeof AuthenticatedAccountLayoutIndexRoute
  '/auth/_layout/change-password/': typeof AuthLayoutChangePasswordIndexRoute
  '/auth/_layout/forgot-password/': typeof AuthLayoutForgotPasswordIndexRoute
  '/auth/_layout/login/': typeof AuthLayoutLoginIndexRoute
  '/auth/_layout/registration/': typeof AuthLayoutRegistrationIndexRoute
  '/_authenticated/$tenantSlug/_layout/advertiser': typeof AuthenticatedTenantSlugLayoutAdvertiserRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/affiliate': typeof AuthenticatedTenantSlugLayoutAffiliateRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/finance': typeof AuthenticatedTenantSlugLayoutFinanceRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/finance/_layout': typeof AuthenticatedTenantSlugLayoutFinanceLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/log': typeof AuthenticatedTenantSlugLayoutLogRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/log/_layout': typeof AuthenticatedTenantSlugLayoutLogLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/offer': typeof AuthenticatedTenantSlugLayoutOfferRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/offer/_layout': typeof AuthenticatedTenantSlugLayoutOfferLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report': typeof AuthenticatedTenantSlugLayoutReportRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout': typeof AuthenticatedTenantSlugLayoutReportLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/setting': typeof AuthenticatedTenantSlugLayoutSettingRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/setting/_layout': typeof AuthenticatedTenantSlugLayoutSettingLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool': typeof AuthenticatedTenantSlugLayoutToolRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutRouteWithChildren
  '/$tenantSlug/auth/_layout/change-password/': typeof TenantSlugAuthLayoutChangePasswordIndexRoute
  '/$tenantSlug/auth/_layout/confirm-registration/': typeof TenantSlugAuthLayoutConfirmRegistrationIndexRoute
  '/$tenantSlug/auth/_layout/forgot-password/': typeof TenantSlugAuthLayoutForgotPasswordIndexRoute
  '/$tenantSlug/auth/_layout/login/': typeof TenantSlugAuthLayoutLoginIndexRoute
  '/$tenantSlug/auth/_layout/registration-advertiser/': typeof TenantSlugAuthLayoutRegistrationAdvertiserIndexRoute
  '/$tenantSlug/auth/_layout/registration/': typeof TenantSlugAuthLayoutRegistrationIndexRoute
  '/$tenantSlug/processes/_layout/$processId/': typeof TenantSlugProcessesLayoutProcessIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/finance/': typeof AuthenticatedTenantSlugLayoutFinanceIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/': typeof AuthenticatedTenantSlugLayoutLogIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/': typeof AuthenticatedTenantSlugLayoutOfferIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/': typeof AuthenticatedTenantSlugLayoutReportIndexRoute
  '/_authenticated/$tenantSlug/_layout/setting/': typeof AuthenticatedTenantSlugLayoutSettingIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/': typeof AuthenticatedTenantSlugLayoutToolIndexRoute
  '/_authenticated/account/_layout/catalog/': typeof AuthenticatedAccountLayoutCatalogIndexRoute
  '/_authenticated/account/_layout/partners/': typeof AuthenticatedAccountLayoutPartnersIndexRoute
  '/_authenticated/account/_layout/settings/': typeof AuthenticatedAccountLayoutSettingsIndexRoute
  '/$tenantSlug/auth/_layout/accept-invitation/$id/$hash': typeof TenantSlugAuthLayoutAcceptInvitationIdHashRoute
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutIndexRoute
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout/': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutIndexRoute
  '/auth/_layout/activate/$userId/$emailHash/': typeof AuthLayoutActivateUserIdEmailHashIndexRoute
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/offer': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutRouteWithChildren
  '/$tenantSlug/auth/_layout/activate/$userId/$emailHash/': typeof TenantSlugAuthLayoutActivateUserIdEmailHashIndexRoute
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutCommissionIndexRoute
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestIndexRoute
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutTransactionIndexRoute
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionIndexRoute
  '/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/': typeof AuthenticatedTenantSlugLayoutFinanceLayoutBonusIndexRoute
  '/_authenticated/$tenantSlug/_layout/finance/_layout/cost/': typeof AuthenticatedTenantSlugLayoutFinanceLayoutCostIndexRoute
  '/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/': typeof AuthenticatedTenantSlugLayoutFinanceLayoutPenaltyIndexRoute
  '/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/': typeof AuthenticatedTenantSlugLayoutFinanceLayoutRevenueIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/api-old/': typeof AuthenticatedTenantSlugLayoutLogLayoutApiOldIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/api/': typeof AuthenticatedTenantSlugLayoutLogLayoutApiIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/click/': typeof AuthenticatedTenantSlugLayoutLogLayoutClickIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/conversion/': typeof AuthenticatedTenantSlugLayoutLogLayoutConversionIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/lead/': typeof AuthenticatedTenantSlugLayoutLogLayoutLeadIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/': typeof AuthenticatedTenantSlugLayoutLogLayoutPingtreeIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/structure/': typeof AuthenticatedTenantSlugLayoutLogLayoutStructureIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/validation/': typeof AuthenticatedTenantSlugLayoutLogLayoutValidationIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/event/': typeof AuthenticatedTenantSlugLayoutReportLayoutEventIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/offer/': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/performance/': typeof AuthenticatedTenantSlugLayoutReportLayoutPerformanceIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/ping/': typeof AuthenticatedTenantSlugLayoutReportLayoutPingIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/transaction/': typeof AuthenticatedTenantSlugLayoutReportLayoutTransactionIndexRoute
  '/_authenticated/$tenantSlug/_layout/setting/_layout/field/': typeof AuthenticatedTenantSlugLayoutSettingLayoutFieldIndexRoute
  '/_authenticated/$tenantSlug/_layout/setting/_layout/general/': typeof AuthenticatedTenantSlugLayoutSettingLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/setting/_layout/plan/': typeof AuthenticatedTenantSlugLayoutSettingLayoutPlanIndexRoute
  '/_authenticated/$tenantSlug/_layout/setting/_layout/tag/': typeof AuthenticatedTenantSlugLayoutSettingLayoutTagIndexRoute
  '/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/': typeof AuthenticatedTenantSlugLayoutSettingLayoutTrackingIndexRoute
  '/_authenticated/$tenantSlug/_layout/setting/_layout/user/': typeof AuthenticatedTenantSlugLayoutSettingLayoutUserIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestOfferIndexRoute
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutRequestPayoutIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutEntryIndexRoute
  '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/': typeof AuthenticatedTenantSlugLayoutAdvertiserLayoutRequestLayoutPayoutIndexRoute
  '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/': typeof AuthenticatedTenantSlugLayoutAffiliateLayoutCommissionLayoutCommissionGroupIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackStepsIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutS2sPostbackIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutToIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiStepsIndexRoute
  '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/': typeof AuthenticatedTenantSlugLayoutLogLayoutTrackingLayoutTrackingApiIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/': typeof AuthenticatedTenantSlugLayoutReportLayoutAdvertiserLayoutUserIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/': typeof AuthenticatedTenantSlugLayoutReportLayoutAffiliateLayoutUserIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/': typeof AuthenticatedTenantSlugLayoutReportLayoutOfferLayoutOfferIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/': typeof AuthenticatedTenantSlugLayoutReportLayoutPingtreeLayoutPingtreeIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFunnelIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutScreenIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutApiIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutFormIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/': typeof AuthenticatedTenantSlugLayoutOfferLayoutDetailOfferIdLayoutLinkIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutApiIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFilterIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutFormIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutLinkIndexRoute
  '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/': typeof AuthenticatedTenantSlugLayoutOfferLayoutEditOfferIdLayoutPingtreeIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutRouteWithChildren
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutEditorIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutValidationLayoutScenarioIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/': typeof AuthenticatedTenantSlugLayoutToolLayoutDesignLayoutFormLayoutFormIdLayoutPreviewIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorOldIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutEditorIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutScenarioLayoutIntegrationLayoutIntegrationIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutFeedLayoutFormStructureIdLayoutStructureIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutLeadLayoutFormStructureIdLayoutStructureIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutEditorOldIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/': typeof AuthenticatedTenantSlugLayoutToolLayoutStructureLayoutUserLayoutFormStructureIdLayoutStructureIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorOldIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutEditorIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutS2sPostbackLayoutIdLayoutGeneralIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorOldIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutEditorIndexRoute
  '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/': typeof AuthenticatedTenantSlugLayoutToolLayoutTrackingLayoutTrackingApiLayoutIdLayoutGeneralIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/auth'
    | '/'
    | '/$tenantSlug/auth'
    | '/$tenantSlug/processes'
    | '/$tenantSlug'
    | '/account'
    | '/$tenantSlug/confirm-deletion'
    | '/$tenantSlug/no-access'
    | '/$tenantSlug/'
    | '/account/'
    | '/auth/change-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/registration'
    | '/$tenantSlug/advertiser'
    | '/$tenantSlug/affiliate'
    | '/$tenantSlug/finance'
    | '/$tenantSlug/log'
    | '/$tenantSlug/offer'
    | '/$tenantSlug/report'
    | '/$tenantSlug/setting'
    | '/$tenantSlug/tool'
    | '/$tenantSlug/auth/change-password'
    | '/$tenantSlug/auth/confirm-registration'
    | '/$tenantSlug/auth/forgot-password'
    | '/$tenantSlug/auth/login'
    | '/$tenantSlug/auth/registration-advertiser'
    | '/$tenantSlug/auth/registration'
    | '/$tenantSlug/processes/$processId'
    | '/$tenantSlug/finance/'
    | '/$tenantSlug/log/'
    | '/$tenantSlug/offer/'
    | '/$tenantSlug/report/'
    | '/$tenantSlug/setting/'
    | '/$tenantSlug/tool/'
    | '/account/catalog'
    | '/account/partners'
    | '/account/settings'
    | '/$tenantSlug/auth/accept-invitation/$id/$hash'
    | '/$tenantSlug/advertiser/'
    | '/$tenantSlug/affiliate/'
    | '/auth/activate/$userId/$emailHash'
    | '/$tenantSlug/advertiser/request'
    | '/$tenantSlug/affiliate/commission'
    | '/$tenantSlug/log/tracking'
    | '/$tenantSlug/report/advertiser'
    | '/$tenantSlug/report/affiliate'
    | '/$tenantSlug/report/offer'
    | '/$tenantSlug/report/pingtree'
    | '/$tenantSlug/tool/design'
    | '/$tenantSlug/tool/scenario'
    | '/$tenantSlug/tool/structure'
    | '/$tenantSlug/tool/tracking'
    | '/$tenantSlug/tool/validation'
    | '/$tenantSlug/auth/activate/$userId/$emailHash'
    | '/$tenantSlug/advertiser/commission'
    | '/$tenantSlug/advertiser/request/'
    | '/$tenantSlug/advertiser/transaction'
    | '/$tenantSlug/affiliate/commission/'
    | '/$tenantSlug/finance/bonus'
    | '/$tenantSlug/finance/cost'
    | '/$tenantSlug/finance/penalty'
    | '/$tenantSlug/finance/revenue'
    | '/$tenantSlug/log/api-old'
    | '/$tenantSlug/log/api'
    | '/$tenantSlug/log/click'
    | '/$tenantSlug/log/conversion'
    | '/$tenantSlug/log/lead'
    | '/$tenantSlug/log/pingtree'
    | '/$tenantSlug/log/structure'
    | '/$tenantSlug/log/tracking/'
    | '/$tenantSlug/log/validation'
    | '/$tenantSlug/report/advertiser/'
    | '/$tenantSlug/report/affiliate/'
    | '/$tenantSlug/report/event'
    | '/$tenantSlug/report/offer/'
    | '/$tenantSlug/report/performance'
    | '/$tenantSlug/report/ping'
    | '/$tenantSlug/report/pingtree/'
    | '/$tenantSlug/report/transaction'
    | '/$tenantSlug/setting/field'
    | '/$tenantSlug/setting/general'
    | '/$tenantSlug/setting/plan'
    | '/$tenantSlug/setting/tag'
    | '/$tenantSlug/setting/tracking'
    | '/$tenantSlug/setting/user'
    | '/$tenantSlug/tool/design/'
    | '/$tenantSlug/tool/scenario/'
    | '/$tenantSlug/tool/structure/'
    | '/$tenantSlug/tool/tracking/'
    | '/$tenantSlug/tool/validation/'
    | '/$tenantSlug/offer/detail/$offerId'
    | '/$tenantSlug/offer/edit/$offerId'
    | '/$tenantSlug/affiliate/request/offer'
    | '/$tenantSlug/affiliate/request/payout'
    | '/$tenantSlug/offer/detail/$offerId/'
    | '/$tenantSlug/offer/edit/$offerId/'
    | '/$tenantSlug/tool/design/form'
    | '/$tenantSlug/tool/scenario/integration'
    | '/$tenantSlug/tool/structure/feed'
    | '/$tenantSlug/tool/structure/lead'
    | '/$tenantSlug/tool/structure/user'
    | '/$tenantSlug/tool/tracking/s2s-postback'
    | '/$tenantSlug/tool/tracking/tracking-api'
    | '/$tenantSlug/tool/validation/$scenarioId'
    | '/$tenantSlug/advertiser/request/entry'
    | '/$tenantSlug/advertiser/request/payout'
    | '/$tenantSlug/affiliate/commission/$commissionGroupId'
    | '/$tenantSlug/log/tracking/s2s-postback-steps'
    | '/$tenantSlug/log/tracking/s2s-postback'
    | '/$tenantSlug/log/tracking/to'
    | '/$tenantSlug/log/tracking/tracking-api-steps'
    | '/$tenantSlug/log/tracking/tracking-api'
    | '/$tenantSlug/report/advertiser/$userId'
    | '/$tenantSlug/report/affiliate/$userId'
    | '/$tenantSlug/report/offer/$offerId'
    | '/$tenantSlug/report/pingtree/$pingtreeId'
    | '/$tenantSlug/tool/design/form/'
    | '/$tenantSlug/tool/design/funnel'
    | '/$tenantSlug/tool/design/screen'
    | '/$tenantSlug/tool/scenario/integration/'
    | '/$tenantSlug/tool/structure/feed/'
    | '/$tenantSlug/tool/structure/lead/'
    | '/$tenantSlug/tool/structure/user/'
    | '/$tenantSlug/tool/tracking/s2s-postback/'
    | '/$tenantSlug/tool/tracking/tracking-api/'
    | '/$tenantSlug/tool/validation/$scenarioId/'
    | '/$tenantSlug/offer/detail/$offerId/api'
    | '/$tenantSlug/offer/detail/$offerId/form'
    | '/$tenantSlug/offer/detail/$offerId/link'
    | '/$tenantSlug/offer/edit/$offerId/api'
    | '/$tenantSlug/offer/edit/$offerId/filter'
    | '/$tenantSlug/offer/edit/$offerId/form'
    | '/$tenantSlug/offer/edit/$offerId/general'
    | '/$tenantSlug/offer/edit/$offerId/link'
    | '/$tenantSlug/offer/edit/$offerId/pingtree'
    | '/$tenantSlug/tool/design/form/$formId'
    | '/$tenantSlug/tool/scenario/integration/$integrationId'
    | '/$tenantSlug/tool/structure/feed/$formStructureId'
    | '/$tenantSlug/tool/structure/lead/$formStructureId'
    | '/$tenantSlug/tool/structure/user/$formStructureId'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id'
    | '/$tenantSlug/tool/tracking/tracking-api/$id'
    | '/$tenantSlug/tool/design/form/$formId/'
    | '/$tenantSlug/tool/scenario/integration/$integrationId/'
    | '/$tenantSlug/tool/structure/feed/$formStructureId/'
    | '/$tenantSlug/tool/structure/lead/$formStructureId/'
    | '/$tenantSlug/tool/structure/user/$formStructureId/'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id/'
    | '/$tenantSlug/tool/tracking/tracking-api/$id/'
    | '/$tenantSlug/tool/validation/$scenarioId/editor'
    | '/$tenantSlug/tool/validation/$scenarioId/general'
    | '/$tenantSlug/tool/design/form/$formId/general'
    | '/$tenantSlug/tool/design/form/$formId/preview'
    | '/$tenantSlug/tool/scenario/integration/$integrationId/editor-old'
    | '/$tenantSlug/tool/scenario/integration/$integrationId/editor'
    | '/$tenantSlug/tool/scenario/integration/$integrationId/general'
    | '/$tenantSlug/tool/structure/feed/$formStructureId/editor-old'
    | '/$tenantSlug/tool/structure/feed/$formStructureId/general'
    | '/$tenantSlug/tool/structure/feed/$formStructureId/structure'
    | '/$tenantSlug/tool/structure/lead/$formStructureId/editor-old'
    | '/$tenantSlug/tool/structure/lead/$formStructureId/general'
    | '/$tenantSlug/tool/structure/lead/$formStructureId/structure'
    | '/$tenantSlug/tool/structure/user/$formStructureId/editor-old'
    | '/$tenantSlug/tool/structure/user/$formStructureId/general'
    | '/$tenantSlug/tool/structure/user/$formStructureId/structure'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id/editor-old'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id/editor'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id/general'
    | '/$tenantSlug/tool/tracking/tracking-api/$id/editor-old'
    | '/$tenantSlug/tool/tracking/tracking-api/$id/editor'
    | '/$tenantSlug/tool/tracking/tracking-api/$id/general'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/'
    | '/$tenantSlug/auth'
    | '/$tenantSlug/processes'
    | '/$tenantSlug'
    | '/account'
    | '/$tenantSlug/confirm-deletion'
    | '/$tenantSlug/no-access'
    | '/auth/change-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/registration'
    | '/$tenantSlug/advertiser'
    | '/$tenantSlug/affiliate'
    | '/$tenantSlug/finance'
    | '/$tenantSlug/log'
    | '/$tenantSlug/offer'
    | '/$tenantSlug/report'
    | '/$tenantSlug/setting'
    | '/$tenantSlug/tool'
    | '/$tenantSlug/auth/change-password'
    | '/$tenantSlug/auth/confirm-registration'
    | '/$tenantSlug/auth/forgot-password'
    | '/$tenantSlug/auth/login'
    | '/$tenantSlug/auth/registration-advertiser'
    | '/$tenantSlug/auth/registration'
    | '/$tenantSlug/processes/$processId'
    | '/account/catalog'
    | '/account/partners'
    | '/account/settings'
    | '/$tenantSlug/auth/accept-invitation/$id/$hash'
    | '/auth/activate/$userId/$emailHash'
    | '/$tenantSlug/advertiser/request'
    | '/$tenantSlug/affiliate/commission'
    | '/$tenantSlug/log/tracking'
    | '/$tenantSlug/report/advertiser'
    | '/$tenantSlug/report/affiliate'
    | '/$tenantSlug/report/offer'
    | '/$tenantSlug/report/pingtree'
    | '/$tenantSlug/tool/design'
    | '/$tenantSlug/tool/scenario'
    | '/$tenantSlug/tool/structure'
    | '/$tenantSlug/tool/tracking'
    | '/$tenantSlug/tool/validation'
    | '/$tenantSlug/auth/activate/$userId/$emailHash'
    | '/$tenantSlug/advertiser/commission'
    | '/$tenantSlug/advertiser/transaction'
    | '/$tenantSlug/finance/bonus'
    | '/$tenantSlug/finance/cost'
    | '/$tenantSlug/finance/penalty'
    | '/$tenantSlug/finance/revenue'
    | '/$tenantSlug/log/api-old'
    | '/$tenantSlug/log/api'
    | '/$tenantSlug/log/click'
    | '/$tenantSlug/log/conversion'
    | '/$tenantSlug/log/lead'
    | '/$tenantSlug/log/pingtree'
    | '/$tenantSlug/log/structure'
    | '/$tenantSlug/log/validation'
    | '/$tenantSlug/report/event'
    | '/$tenantSlug/report/performance'
    | '/$tenantSlug/report/ping'
    | '/$tenantSlug/report/transaction'
    | '/$tenantSlug/setting/field'
    | '/$tenantSlug/setting/general'
    | '/$tenantSlug/setting/plan'
    | '/$tenantSlug/setting/tag'
    | '/$tenantSlug/setting/tracking'
    | '/$tenantSlug/setting/user'
    | '/$tenantSlug/offer/detail/$offerId'
    | '/$tenantSlug/offer/edit/$offerId'
    | '/$tenantSlug/affiliate/request/offer'
    | '/$tenantSlug/affiliate/request/payout'
    | '/$tenantSlug/tool/design/form'
    | '/$tenantSlug/tool/scenario/integration'
    | '/$tenantSlug/tool/structure/feed'
    | '/$tenantSlug/tool/structure/lead'
    | '/$tenantSlug/tool/structure/user'
    | '/$tenantSlug/tool/tracking/s2s-postback'
    | '/$tenantSlug/tool/tracking/tracking-api'
    | '/$tenantSlug/tool/validation/$scenarioId'
    | '/$tenantSlug/advertiser/request/entry'
    | '/$tenantSlug/advertiser/request/payout'
    | '/$tenantSlug/affiliate/commission/$commissionGroupId'
    | '/$tenantSlug/log/tracking/s2s-postback-steps'
    | '/$tenantSlug/log/tracking/s2s-postback'
    | '/$tenantSlug/log/tracking/to'
    | '/$tenantSlug/log/tracking/tracking-api-steps'
    | '/$tenantSlug/log/tracking/tracking-api'
    | '/$tenantSlug/report/advertiser/$userId'
    | '/$tenantSlug/report/affiliate/$userId'
    | '/$tenantSlug/report/offer/$offerId'
    | '/$tenantSlug/report/pingtree/$pingtreeId'
    | '/$tenantSlug/tool/design/funnel'
    | '/$tenantSlug/tool/design/screen'
    | '/$tenantSlug/offer/detail/$offerId/api'
    | '/$tenantSlug/offer/detail/$offerId/form'
    | '/$tenantSlug/offer/detail/$offerId/link'
    | '/$tenantSlug/offer/edit/$offerId/api'
    | '/$tenantSlug/offer/edit/$offerId/filter'
    | '/$tenantSlug/offer/edit/$offerId/form'
    | '/$tenantSlug/offer/edit/$offerId/general'
    | '/$tenantSlug/offer/edit/$offerId/link'
    | '/$tenantSlug/offer/edit/$offerId/pingtree'
    | '/$tenantSlug/tool/design/form/$formId'
    | '/$tenantSlug/tool/scenario/integration/$integrationId'
    | '/$tenantSlug/tool/structure/feed/$formStructureId'
    | '/$tenantSlug/tool/structure/lead/$formStructureId'
    | '/$tenantSlug/tool/structure/user/$formStructureId'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id'
    | '/$tenantSlug/tool/tracking/tracking-api/$id'
    | '/$tenantSlug/tool/validation/$scenarioId/editor'
    | '/$tenantSlug/tool/validation/$scenarioId/general'
    | '/$tenantSlug/tool/design/form/$formId/general'
    | '/$tenantSlug/tool/design/form/$formId/preview'
    | '/$tenantSlug/tool/scenario/integration/$integrationId/editor-old'
    | '/$tenantSlug/tool/scenario/integration/$integrationId/editor'
    | '/$tenantSlug/tool/scenario/integration/$integrationId/general'
    | '/$tenantSlug/tool/structure/feed/$formStructureId/editor-old'
    | '/$tenantSlug/tool/structure/feed/$formStructureId/general'
    | '/$tenantSlug/tool/structure/feed/$formStructureId/structure'
    | '/$tenantSlug/tool/structure/lead/$formStructureId/editor-old'
    | '/$tenantSlug/tool/structure/lead/$formStructureId/general'
    | '/$tenantSlug/tool/structure/lead/$formStructureId/structure'
    | '/$tenantSlug/tool/structure/user/$formStructureId/editor-old'
    | '/$tenantSlug/tool/structure/user/$formStructureId/general'
    | '/$tenantSlug/tool/structure/user/$formStructureId/structure'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id/editor-old'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id/editor'
    | '/$tenantSlug/tool/tracking/s2s-postback/$id/general'
    | '/$tenantSlug/tool/tracking/tracking-api/$id/editor-old'
    | '/$tenantSlug/tool/tracking/tracking-api/$id/editor'
    | '/$tenantSlug/tool/tracking/tracking-api/$id/general'
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth'
    | '/auth/_layout'
    | '/_authenticated/'
    | '/$tenantSlug/auth'
    | '/$tenantSlug/auth/_layout'
    | '/$tenantSlug/processes'
    | '/$tenantSlug/processes/_layout'
    | '/_authenticated/$tenantSlug'
    | '/_authenticated/$tenantSlug/_layout'
    | '/_authenticated/account'
    | '/_authenticated/account/_layout'
    | '/$tenantSlug/confirm-deletion/'
    | '/$tenantSlug/no-access/'
    | '/_authenticated/$tenantSlug/_layout/'
    | '/_authenticated/account/_layout/'
    | '/auth/_layout/change-password/'
    | '/auth/_layout/forgot-password/'
    | '/auth/_layout/login/'
    | '/auth/_layout/registration/'
    | '/_authenticated/$tenantSlug/_layout/advertiser'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout'
    | '/_authenticated/$tenantSlug/_layout/affiliate'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout'
    | '/_authenticated/$tenantSlug/_layout/finance'
    | '/_authenticated/$tenantSlug/_layout/finance/_layout'
    | '/_authenticated/$tenantSlug/_layout/log'
    | '/_authenticated/$tenantSlug/_layout/log/_layout'
    | '/_authenticated/$tenantSlug/_layout/offer'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout'
    | '/_authenticated/$tenantSlug/_layout/report'
    | '/_authenticated/$tenantSlug/_layout/report/_layout'
    | '/_authenticated/$tenantSlug/_layout/setting'
    | '/_authenticated/$tenantSlug/_layout/setting/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout'
    | '/$tenantSlug/auth/_layout/change-password/'
    | '/$tenantSlug/auth/_layout/confirm-registration/'
    | '/$tenantSlug/auth/_layout/forgot-password/'
    | '/$tenantSlug/auth/_layout/login/'
    | '/$tenantSlug/auth/_layout/registration-advertiser/'
    | '/$tenantSlug/auth/_layout/registration/'
    | '/$tenantSlug/processes/_layout/$processId/'
    | '/_authenticated/$tenantSlug/_layout/finance/'
    | '/_authenticated/$tenantSlug/_layout/log/'
    | '/_authenticated/$tenantSlug/_layout/offer/'
    | '/_authenticated/$tenantSlug/_layout/report/'
    | '/_authenticated/$tenantSlug/_layout/setting/'
    | '/_authenticated/$tenantSlug/_layout/tool/'
    | '/_authenticated/account/_layout/catalog/'
    | '/_authenticated/account/_layout/partners/'
    | '/_authenticated/account/_layout/settings/'
    | '/$tenantSlug/auth/_layout/accept-invitation/$id/$hash'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout/'
    | '/auth/_layout/activate/$userId/$emailHash/'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/offer'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout'
    | '/$tenantSlug/auth/_layout/activate/$userId/$emailHash/'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/'
    | '/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/'
    | '/_authenticated/$tenantSlug/_layout/finance/_layout/cost/'
    | '/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/'
    | '/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/api-old/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/api/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/click/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/conversion/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/lead/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/structure/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/validation/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/event/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/offer/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/performance/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/ping/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/transaction/'
    | '/_authenticated/$tenantSlug/_layout/setting/_layout/field/'
    | '/_authenticated/$tenantSlug/_layout/setting/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/setting/_layout/plan/'
    | '/_authenticated/$tenantSlug/_layout/setting/_layout/tag/'
    | '/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/'
    | '/_authenticated/$tenantSlug/_layout/setting/_layout/user/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/'
    | '/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/'
    | '/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/'
    | '/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/'
    | '/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/'
    | '/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/'
    | '/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  TenantSlugAuthRoute: typeof TenantSlugAuthRouteWithChildren
  TenantSlugProcessesRoute: typeof TenantSlugProcessesRouteWithChildren
  TenantSlugConfirmDeletionIndexRoute: typeof TenantSlugConfirmDeletionIndexRoute
  TenantSlugNoAccessIndexRoute: typeof TenantSlugNoAccessIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  TenantSlugAuthRoute: TenantSlugAuthRouteWithChildren,
  TenantSlugProcessesRoute: TenantSlugProcessesRouteWithChildren,
  TenantSlugConfirmDeletionIndexRoute: TenantSlugConfirmDeletionIndexRoute,
  TenantSlugNoAccessIndexRoute: TenantSlugNoAccessIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/auth",
        "/$tenantSlug/auth",
        "/$tenantSlug/processes",
        "/$tenantSlug/confirm-deletion/",
        "/$tenantSlug/no-access/"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/",
        "/_authenticated/$tenantSlug",
        "/_authenticated/account"
      ]
    },
    "/auth": {
      "filePath": "auth",
      "children": [
        "/auth/_layout"
      ]
    },
    "/auth/_layout": {
      "filePath": "auth/_layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/_layout/change-password/",
        "/auth/_layout/forgot-password/",
        "/auth/_layout/login/",
        "/auth/_layout/registration/",
        "/auth/_layout/activate/$userId/$emailHash/"
      ]
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/$tenantSlug/auth": {
      "filePath": "$tenantSlug/auth",
      "children": [
        "/$tenantSlug/auth/_layout"
      ]
    },
    "/$tenantSlug/auth/_layout": {
      "filePath": "$tenantSlug/auth/_layout.tsx",
      "parent": "/$tenantSlug/auth",
      "children": [
        "/$tenantSlug/auth/_layout/change-password/",
        "/$tenantSlug/auth/_layout/confirm-registration/",
        "/$tenantSlug/auth/_layout/forgot-password/",
        "/$tenantSlug/auth/_layout/login/",
        "/$tenantSlug/auth/_layout/registration-advertiser/",
        "/$tenantSlug/auth/_layout/registration/",
        "/$tenantSlug/auth/_layout/accept-invitation/$id/$hash",
        "/$tenantSlug/auth/_layout/activate/$userId/$emailHash/"
      ]
    },
    "/$tenantSlug/processes": {
      "filePath": "$tenantSlug/processes",
      "children": [
        "/$tenantSlug/processes/_layout"
      ]
    },
    "/$tenantSlug/processes/_layout": {
      "filePath": "$tenantSlug/processes/_layout.tsx",
      "parent": "/$tenantSlug/processes",
      "children": [
        "/$tenantSlug/processes/_layout/$processId/"
      ]
    },
    "/_authenticated/$tenantSlug": {
      "filePath": "_authenticated/$tenantSlug",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/$tenantSlug/_layout"
      ]
    },
    "/_authenticated/$tenantSlug/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug",
      "children": [
        "/_authenticated/$tenantSlug/_layout/",
        "/_authenticated/$tenantSlug/_layout/advertiser",
        "/_authenticated/$tenantSlug/_layout/affiliate",
        "/_authenticated/$tenantSlug/_layout/finance",
        "/_authenticated/$tenantSlug/_layout/log",
        "/_authenticated/$tenantSlug/_layout/offer",
        "/_authenticated/$tenantSlug/_layout/report",
        "/_authenticated/$tenantSlug/_layout/setting",
        "/_authenticated/$tenantSlug/_layout/tool"
      ]
    },
    "/_authenticated/account": {
      "filePath": "_authenticated/account",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/account/_layout"
      ]
    },
    "/_authenticated/account/_layout": {
      "filePath": "_authenticated/account/_layout.tsx",
      "parent": "/_authenticated/account",
      "children": [
        "/_authenticated/account/_layout/",
        "/_authenticated/account/_layout/catalog/",
        "/_authenticated/account/_layout/partners/",
        "/_authenticated/account/_layout/settings/"
      ]
    },
    "/$tenantSlug/confirm-deletion/": {
      "filePath": "$tenantSlug/confirm-deletion/index.tsx"
    },
    "/$tenantSlug/no-access/": {
      "filePath": "$tenantSlug/no-access/index.tsx"
    },
    "/_authenticated/$tenantSlug/_layout/": {
      "filePath": "_authenticated/$tenantSlug/_layout/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout"
    },
    "/_authenticated/account/_layout/": {
      "filePath": "_authenticated/account/_layout/index.tsx",
      "parent": "/_authenticated/account/_layout"
    },
    "/auth/_layout/change-password/": {
      "filePath": "auth/_layout/change-password/index.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/forgot-password/": {
      "filePath": "auth/_layout/forgot-password/index.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/login/": {
      "filePath": "auth/_layout/login/index.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/registration/": {
      "filePath": "auth/_layout/registration/index.tsx",
      "parent": "/auth/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/advertiser": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser",
      "children": [
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/",
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request",
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/",
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/affiliate": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate",
      "children": [
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout/",
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission",
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/",
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/finance": {
      "filePath": "_authenticated/$tenantSlug/_layout/finance",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/finance/_layout",
        "/_authenticated/$tenantSlug/_layout/finance/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/finance/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/finance/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/finance",
      "children": [
        "/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/",
        "/_authenticated/$tenantSlug/_layout/finance/_layout/cost/",
        "/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/",
        "/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/log": {
      "filePath": "_authenticated/$tenantSlug/_layout/log",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/log/_layout",
        "/_authenticated/$tenantSlug/_layout/log/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log",
      "children": [
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking",
        "/_authenticated/$tenantSlug/_layout/log/_layout/api-old/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/api/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/click/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/conversion/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/lead/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/structure/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/validation/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/offer": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/offer/_layout",
        "/_authenticated/$tenantSlug/_layout/offer/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer",
      "children": [
        "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report": {
      "filePath": "_authenticated/$tenantSlug/_layout/report",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout",
        "/_authenticated/$tenantSlug/_layout/report/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser",
        "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate",
        "/_authenticated/$tenantSlug/_layout/report/_layout/offer",
        "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree",
        "/_authenticated/$tenantSlug/_layout/report/_layout/event/",
        "/_authenticated/$tenantSlug/_layout/report/_layout/performance/",
        "/_authenticated/$tenantSlug/_layout/report/_layout/ping/",
        "/_authenticated/$tenantSlug/_layout/report/_layout/transaction/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/setting": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/setting/_layout",
        "/_authenticated/$tenantSlug/_layout/setting/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/setting/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting",
      "children": [
        "/_authenticated/$tenantSlug/_layout/setting/_layout/field/",
        "/_authenticated/$tenantSlug/_layout/setting/_layout/general/",
        "/_authenticated/$tenantSlug/_layout/setting/_layout/plan/",
        "/_authenticated/$tenantSlug/_layout/setting/_layout/tag/",
        "/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/",
        "/_authenticated/$tenantSlug/_layout/setting/_layout/user/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool",
      "parent": "/_authenticated/$tenantSlug/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation"
      ]
    },
    "/$tenantSlug/auth/_layout/change-password/": {
      "filePath": "$tenantSlug/auth/_layout/change-password/index.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/$tenantSlug/auth/_layout/confirm-registration/": {
      "filePath": "$tenantSlug/auth/_layout/confirm-registration/index.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/$tenantSlug/auth/_layout/forgot-password/": {
      "filePath": "$tenantSlug/auth/_layout/forgot-password/index.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/$tenantSlug/auth/_layout/login/": {
      "filePath": "$tenantSlug/auth/_layout/login/index.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/$tenantSlug/auth/_layout/registration-advertiser/": {
      "filePath": "$tenantSlug/auth/_layout/registration-advertiser/index.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/$tenantSlug/auth/_layout/registration/": {
      "filePath": "$tenantSlug/auth/_layout/registration/index.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/$tenantSlug/processes/_layout/$processId/": {
      "filePath": "$tenantSlug/processes/_layout/$processId/index.tsx",
      "parent": "/$tenantSlug/processes/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/finance/": {
      "filePath": "_authenticated/$tenantSlug/_layout/finance/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/finance"
    },
    "/_authenticated/$tenantSlug/_layout/log/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log"
    },
    "/_authenticated/$tenantSlug/_layout/offer/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer"
    },
    "/_authenticated/$tenantSlug/_layout/report/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report"
    },
    "/_authenticated/$tenantSlug/_layout/setting/": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting"
    },
    "/_authenticated/$tenantSlug/_layout/tool/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool"
    },
    "/_authenticated/account/_layout/catalog/": {
      "filePath": "_authenticated/account/_layout/catalog/index.tsx",
      "parent": "/_authenticated/account/_layout"
    },
    "/_authenticated/account/_layout/partners/": {
      "filePath": "_authenticated/account/_layout/partners/index.tsx",
      "parent": "/_authenticated/account/_layout"
    },
    "/_authenticated/account/_layout/settings/": {
      "filePath": "_authenticated/account/_layout/settings/index.tsx",
      "parent": "/_authenticated/account/_layout"
    },
    "/$tenantSlug/auth/_layout/accept-invitation/$id/$hash": {
      "filePath": "$tenantSlug/auth/_layout/accept-invitation/$id/$hash.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate/_layout"
    },
    "/auth/_layout/activate/$userId/$emailHash/": {
      "filePath": "auth/_layout/activate/$userId/$emailHash/index.tsx",
      "parent": "/auth/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/request",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout",
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request",
      "children": [
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/",
        "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout/commission",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout",
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission",
      "children": [
        "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout",
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout/tracking",
      "children": [
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/",
        "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/advertiser",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout",
        "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/affiliate",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout",
        "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/offer": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/offer",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout",
        "/_authenticated/$tenantSlug/_layout/report/_layout/offer/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/offer",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/pingtree",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout",
        "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree",
      "children": [
        "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/validation",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId"
      ]
    },
    "/$tenantSlug/auth/_layout/activate/$userId/$emailHash/": {
      "filePath": "$tenantSlug/auth/_layout/activate/$userId/$emailHash/index.tsx",
      "parent": "/$tenantSlug/auth/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/commission/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/request/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request"
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/transaction/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission"
    },
    "/_authenticated/$tenantSlug/_layout/finance/_layout/bonus/": {
      "filePath": "_authenticated/$tenantSlug/_layout/finance/_layout/bonus/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/finance/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/finance/_layout/cost/": {
      "filePath": "_authenticated/$tenantSlug/_layout/finance/_layout/cost/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/finance/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/finance/_layout/penalty/": {
      "filePath": "_authenticated/$tenantSlug/_layout/finance/_layout/penalty/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/finance/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/finance/_layout/revenue/": {
      "filePath": "_authenticated/$tenantSlug/_layout/finance/_layout/revenue/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/finance/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/api-old/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/api-old/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/api/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/api/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/click/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/click/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/conversion/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/conversion/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/lead/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/lead/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/pingtree/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/pingtree/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/structure/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/structure/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout/tracking"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/validation/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/validation/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/advertiser/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/affiliate/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/event/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/event/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/offer/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/offer/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/offer"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/performance/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/performance/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/ping/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/ping/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/pingtree/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/transaction/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/transaction/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/setting/_layout/field/": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/_layout/field/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/setting/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/setting/_layout/plan/": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/_layout/plan/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/setting/_layout/tag/": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/_layout/tag/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/setting/_layout/tracking/": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/_layout/tracking/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/setting/_layout/user/": {
      "filePath": "_authenticated/$tenantSlug/_layout/setting/_layout/user/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/setting/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/validation"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/",
        "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout/request/offer/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout/request/payout/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/": {
      "filePath": "_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/": {
      "filePath": "_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout/$userId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout/$userId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/affiliate/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/funnel/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/screen/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/link/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/api/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/filter/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/form/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/link/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/": {
      "filePath": "_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/pingtree/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id",
      "children": [
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/",
        "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/"
      ]
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/editor/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout/preview/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/editor-old/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout/structure/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/editor-old/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/editor-old/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout/structure/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/_layout/$formStructureId/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor-old/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/editor/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout/$id/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout"
    },
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/": {
      "filePath": "_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general/index.tsx",
      "parent": "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
